// @generated by protoc-gen-es v2.15.0 with parameter "target=ts"
// @generated from file bazivan/v1/table.proto (package bazivan.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bazivan/v1/table.proto.
 */
export const file_bazivan_v1_table: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * یک کارت: خال و رتبه با همان ترتیبِ کلاینت (Hearts, Diamonds, Spades, Clubs / Ace..King).
 *
 * @generated from message bazivan.v1.Card
 */
export type Card = Message<"bazivan.v1.Card"> & {
  /**
   * @generated from field: bazivan.v1.Suit suit = 1;
   */
  suit: Suit;

  /**
   * @generated from field: bazivan.v1.Rank rank = 2;
   */
  rank: Rank;
};

/**
 * Describes the message bazivan.v1.Card.
 * Use `create(CardSchema)` to create a new message.
 */
export const CardSchema: GenMessage<Card> = /*@__PURE__*/
  messageDesc(file_bazivan_v1_table, 0);

/**
 * هر فریمِ WebSocket یک Envelope است. seq را کلاینت می‌گذارد و سرور در پاسخِ مستقیم برمی‌گرداند.
 *
 * @generated from message bazivan.v1.Envelope
 */
export type Envelope = Message<"bazivan.v1.Envelope"> & {
  /**
   * @generated from field: uint32 seq = 1;
   */
  seq: number;

  /**
   * @generated from oneof bazivan.v1.Envelope.msg
   */
  msg: {
    /**
     * کلاینت → سرور
     *
     * @generated from field: bazivan.v1.Hello hello = 10;
     */
    value: Hello;
    case: "hello";
  } | {
    /**
     * @generated from field: bazivan.v1.QuickMatch quick_match = 11;
     */
    value: QuickMatch;
    case: "quickMatch";
  } | {
    /**
     * @generated from field: bazivan.v1.CancelMatch cancel_match = 12;
     */
    value: CancelMatch;
    case: "cancelMatch";
  } | {
    /**
     * @generated from field: bazivan.v1.CreateRoom create_room = 13;
     */
    value: CreateRoom;
    case: "createRoom";
  } | {
    /**
     * @generated from field: bazivan.v1.JoinRoom join_room = 14;
     */
    value: JoinRoom;
    case: "joinRoom";
  } | {
    /**
     * @generated from field: bazivan.v1.LeaveRoom leave_room = 15;
     */
    value: LeaveRoom;
    case: "leaveRoom";
  } | {
    /**
     * @generated from field: bazivan.v1.StartRoom start_room = 16;
     */
    value: StartRoom;
    case: "startRoom";
  } | {
    /**
     * @generated from field: bazivan.v1.CallTrump call_trump = 17;
     */
    value: CallTrump;
    case: "callTrump";
  } | {
    /**
     * @generated from field: bazivan.v1.PlayCard play_card = 18;
     */
    value: PlayCard;
    case: "playCard";
  } | {
    /**
     * @generated from field: bazivan.v1.Ping ping = 19;
     */
    value: Ping;
    case: "ping";
  } | {
    /**
     * @generated from field: bazivan.v1.CbPlay cb_play = 20;
     */
    value: CbPlay;
    case: "cbPlay";
  } | {
    /**
     * @generated from field: bazivan.v1.CbPickCapture cb_pick_capture = 21;
     */
    value: CbPickCapture;
    case: "cbPickCapture";
  } | {
    /**
     * @generated from field: bazivan.v1.HkPlay hk_play = 22;
     */
    value: HkPlay;
    case: "hkPlay";
  } | {
    /**
     * @generated from field: bazivan.v1.HkDraw hk_draw = 23;
     */
    value: HkDraw;
    case: "hkDraw";
  } | {
    /**
     * @generated from field: bazivan.v1.HkPickSuit hk_pick_suit = 24;
     */
    value: HkPickSuit;
    case: "hkPickSuit";
  } | {
    /**
     * @generated from field: bazivan.v1.HkPickTarget hk_pick_target = 25;
     */
    value: HkPickTarget;
    case: "hkPickTarget";
  } | {
    /**
     * @generated from field: bazivan.v1.HkCallWarn hk_call_warn = 26;
     */
    value: HkCallWarn;
    case: "hkCallWarn";
  } | {
    /**
     * @generated from field: bazivan.v1.HkCatch hk_catch = 27;
     */
    value: HkCatch;
    case: "hkCatch";
  } | {
    /**
     * @generated from field: bazivan.v1.HkPickOffer hk_pick_offer = 28;
     */
    value: HkPickOffer;
    case: "hkPickOffer";
  } | {
    /**
     * @generated from field: bazivan.v1.SetCarpet set_carpet = 29;
     */
    value: SetCarpet;
    case: "setCarpet";
  } | {
    /**
     * @generated from field: bazivan.v1.ClaimOffline claim_offline = 42;
     */
    value: ClaimOffline;
    case: "claimOffline";
  } | {
    /**
     * @generated from field: bazivan.v1.SpendCoins spend_coins = 43;
     */
    value: SpendCoins;
    case: "spendCoins";
  } | {
    /**
     * @generated from field: bazivan.v1.BuyItem buy_item = 44;
     */
    value: BuyItem;
    case: "buyItem";
  } | {
    /**
     * @generated from field: bazivan.v1.StartTrial start_trial = 47;
     */
    value: StartTrial;
    case: "startTrial";
  } | {
    /**
     * @generated from field: bazivan.v1.ListTables list_tables = 48;
     */
    value: ListTables;
    case: "listTables";
  } | {
    /**
     * @generated from field: bazivan.v1.WatchTable watch_table = 49;
     */
    value: WatchTable;
    case: "watchTable";
  } | {
    /**
     * @generated from field: bazivan.v1.StopWatch stop_watch = 50;
     */
    value: StopWatch;
    case: "stopWatch";
  } | {
    /**
     * @generated from field: bazivan.v1.SetPublic set_public = 51;
     */
    value: SetPublic;
    case: "setPublic";
  } | {
    /**
     * @generated from field: bazivan.v1.SendChat send_chat = 53;
     */
    value: SendChat;
    case: "sendChat";
  } | {
    /**
     * @generated from field: bazivan.v1.SetChatOpen set_chat_open = 54;
     */
    value: SetChatOpen;
    case: "setChatOpen";
  } | {
    /**
     * @generated from field: bazivan.v1.Resync resync = 57;
     */
    value: Resync;
    case: "resync";
  } | {
    /**
     * @generated from field: bazivan.v1.ShBid sh_bid = 59;
     */
    value: ShBid;
    case: "shBid";
  } | {
    /**
     * @generated from field: bazivan.v1.ShDiscard sh_discard = 60;
     */
    value: ShDiscard;
    case: "shDiscard";
  } | {
    /**
     * @generated from field: bazivan.v1.ShTrump sh_trump = 61;
     */
    value: ShTrump;
    case: "shTrump";
  } | {
    /**
     * @generated from field: bazivan.v1.ShPlay sh_play = 62;
     */
    value: ShPlay;
    case: "shPlay";
  } | {
    /**
     * @generated from field: bazivan.v1.AskToday ask_today = 65;
     */
    value: AskToday;
    case: "askToday";
  } | {
    /**
     * @generated from field: bazivan.v1.ClaimMission claim_mission = 66;
     */
    value: ClaimMission;
    case: "claimMission";
  } | {
    /**
     * سرور → کلاینت
     *
     * @generated from field: bazivan.v1.Welcome welcome = 30;
     */
    value: Welcome;
    case: "welcome";
  } | {
    /**
     * @generated from field: bazivan.v1.Error error = 31;
     */
    value: Error;
    case: "error";
  } | {
    /**
     * @generated from field: bazivan.v1.MatchStatus match_status = 32;
     */
    value: MatchStatus;
    case: "matchStatus";
  } | {
    /**
     * @generated from field: bazivan.v1.RoomState room_state = 33;
     */
    value: RoomState;
    case: "roomState";
  } | {
    /**
     * @generated from field: bazivan.v1.TableState table_state = 34;
     */
    value: TableState;
    case: "tableState";
  } | {
    /**
     * @generated from field: bazivan.v1.TableEvent table_event = 35;
     */
    value: TableEvent;
    case: "tableEvent";
  } | {
    /**
     * @generated from field: bazivan.v1.Pong pong = 36;
     */
    value: Pong;
    case: "pong";
  } | {
    /**
     * @generated from field: bazivan.v1.CbTableState cb_state = 37;
     */
    value: CbTableState;
    case: "cbState";
  } | {
    /**
     * @generated from field: bazivan.v1.CbEvent cb_event = 38;
     */
    value: CbEvent;
    case: "cbEvent";
  } | {
    /**
     * @generated from field: bazivan.v1.HkTableState hk_state = 39;
     */
    value: HkTableState;
    case: "hkState";
  } | {
    /**
     * @generated from field: bazivan.v1.HkEvent hk_event = 40;
     */
    value: HkEvent;
    case: "hkEvent";
  } | {
    /**
     * @generated from field: bazivan.v1.WalletState wallet = 41;
     */
    value: WalletState;
    case: "wallet";
  } | {
    /**
     * @generated from field: bazivan.v1.InventoryState inventory = 45;
     */
    value: InventoryState;
    case: "inventory";
  } | {
    /**
     * @generated from field: bazivan.v1.SubscriptionState subscription = 46;
     */
    value: SubscriptionState;
    case: "subscription";
  } | {
    /**
     * @generated from field: bazivan.v1.TableList table_list = 52;
     */
    value: TableList;
    case: "tableList";
  } | {
    /**
     * @generated from field: bazivan.v1.ChatMessage chat = 55;
     */
    value: ChatMessage;
    case: "chat";
  } | {
    /**
     * @generated from field: bazivan.v1.ChatHistory chat_history = 56;
     */
    value: ChatHistory;
    case: "chatHistory";
  } | {
    /**
     * @generated from field: bazivan.v1.Notice notice = 58;
     */
    value: Notice;
    case: "notice";
  } | {
    /**
     * @generated from field: bazivan.v1.ShTableState sh_state = 63;
     */
    value: ShTableState;
    case: "shState";
  } | {
    /**
     * @generated from field: bazivan.v1.ShEvent sh_event = 64;
     */
    value: ShEvent;
    case: "shEvent";
  } | {
    /**
     * @generated from field: bazivan.v1.TodayState today = 67;
     */
    value: TodayState;
    case: "today";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message bazivan.v1.Envelope.
 * Use `create(EnvelopeSchema)` to create a new message.
 */
export const EnvelopeSchema: GenMessage<Envelope> = /*@__PURE__*/
  messageDesc(file_bazivan_v1_table, 1);

/**
 * AskToday: «امروز چه خبر است» — بازیِ روز و مأموریت‌ها.
 *
 * نامش GetToday نیست چون تولیدکننده‌ی Go همان‌وقت `GetToday()` را برای
 * فیلدِ پاسخ هم می‌سازد و برای رفعِ برخورد زیرخط می‌چسباند — و آن اسمِ
 * زشت به هر سه کلاینت می‌رسد.
 *
 * درخواستی است و نه بی‌درخواست: کلاینت وقتی می‌پرسد که صفحه‌اش را باز
 * می‌کند، و فرستادنش سرِ هر Hello یعنی هزینه‌ی کسی که اصلاً آن صفحه را
 * باز نمی‌کند.
 *
 * @generated from message bazivan.v1.AskToday
 */
export type AskToday = Message<"bazivan.v1.AskToday"> & {
};

/**
 * Describes the message bazivan.v1.AskToday.
 * Use `create(AskTodaySchema)` to create a new message.
 */
export const AskTodaySchema: GenMessage<AskToday> = /*@__PURE__*/
  messageDesc(file_bazivan_v1_table, 2);

/**
 * ClaimMission: جایزه‌ی یک مأموریتِ کامل‌شده.
 *
 * جوابِ موفق: TodayState ِ تازه + WalletState. خطا: `mission_not_ready`
 * (کامل نشده، یا قبلاً گرفته شده) — یک کد برای هر دو، چون از نگاهِ بازیکن
 * یک چیزند: «این دکمه الان کار نمی‌کند».
 *
 * @generated from message bazivan.v1.ClaimMission
 */
export type ClaimMission = Message<"bazivan.v1.ClaimMission"> & {
  /**
   * @generated from field: string mission_id = 1;
   */
  missionId: string;
};

/**
 * Describes the message bazivan.v1.ClaimMission.
 * Use `create(ClaimMissionSchema)` to create a new message.
 */
export const ClaimMissionSchema: GenMessage<ClaimMission> = /*@__PURE__*/
  messageDesc(file_bazivan_v1_table, 3);

/**
 * TodayState: بازیِ روز و مأموریت‌های امروز.
 *
 * @generated from message bazivan.v1.TodayState
 */
export type TodayState = Message<"bazivan.v1.TodayState"> & {
  /**
   * day: «امروز» به وقتِ تهران، ۲۰۲۶۰۹۲۴. کلاینت با این می‌فهمد عکسش
   * برای روزِ دیگری است و باید دوباره بپرسد.
   *
   * @generated from field: int32 day = 1;
   */
  day: number;

  /**
   * ends_at_ms: نیمه‌شبِ تهران — برای شمارشِ معکوس. کلاینت نباید خودش
   * منطقه‌ی زمانی حساب کند.
   *
   * @generated from field: int64 ends_at_ms = 2;
   */
  endsAtMs: bigint;

  /**
   * daily_game: کلیدِ بازیِ روز. خالی = امروز بازیِ روز ندارد.
   *
   * @generated from field: string daily_game = 3;
   */
  dailyGame: string;

  /**
   * daily_boost: ضریبِ سکه‌ی بازیِ روز روی میزِ **رایگان**. میزِ ورودی‌دار
   * ضریب نمی‌خورد و کلاینت نباید وعده‌اش را بدهد.
   *
   * @generated from field: int32 daily_boost = 4;
   */
  dailyBoost: number;

  /**
   * @generated from field: repeated bazivan.v1.MissionState missions = 5;
   */
  missions: MissionState[];
};

/**
 * Describes the message bazivan.v1.TodayState.
 * Use `create(TodayStateSchema)` to create a new message.
 */
export const TodayStateSchema: GenMessage<TodayState> = /*@__PURE__*/
  messageDesc(file_bazivan_v1_table, 4);

/**
 * MissionState: یک مأموریت با پیشرفتش.
 *
 * @generated from message bazivan.v1.MissionState
 */
export type MissionState = Message<"bazivan.v1.MissionState"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * play | win | play_game | daily_game
   *
   * @generated from field: string kind = 2;
   */
  kind: string;

  /**
   * فقط برای play_game
   *
   * @generated from field: string game = 3;
   */
  game: string;

  /**
   * @generated from field: int32 target = 4;
   */
  target: number;

  /**
   * @generated from field: int32 progress = 5;
   */
  progress: number;

  /**
   * @generated from field: bool claimed = 6;
   */
  claimed: boolean;

  /**
   * @generated from field: int64 reward_coins = 7;
   */
  rewardCoins: bigint;

  /**
   * @generated from field: int64 reward_gems = 8;
   */
  rewardGems: bigint;

  /**
   * @generated from field: int32 reward_xp = 9;
   */
  rewardXp: number;

  /**
   * title: متنِ آماده از پیکربندی. خالی = کلاینت از kind و target بسازد.
   *
   * @generated from field: string title = 10;
   */
  title: string;
};

/**
 * Describes the message bazivan.v1.MissionState.
 * Use `create(MissionStateSchema)` to create a new message.
 */
export const MissionStateSchema: GenMessage<MissionState> = /*@__PURE__*/
  messageDesc(file_bazivan_v1_table, 5);

/**
 * Notice: پیامِ همگانی از پنلِ ادمین — اعلان، هشدارِ تعمیرات، خبرِ رویداد.
 *
 * سرور بی‌درخواست می‌فرستد، به همه‌ی اتصال‌های زنده یا فقط به یک نفر (پاسخِ
 * پشتیبانی). کلاینتی که این پیام را نمی‌شناسد (نسخه‌ی قدیمی) آن را دور
 * می‌ریزد — protobuf فیلدِ ناشناخته را خطا نمی‌گیرد. تاریخچه‌ی اعلان‌ها با
 * GET /v1/inbox هم می‌آید تا بازیکنی که آن لحظه وصل نبود از دست ندهد.
 *
 * @generated from message bazivan.v1.Notice
 */
export type Notice = Message<"bazivan.v1.Notice"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * "info" | "warn" | "event" | "maintenance" | "support"
   *
   * @generated from field: string kind = 2;
   */
  kind: string;

  /**
   * @generated from field: string title = 3;
   */
  title: string;

  /**
   * @generated from field: string body = 4;
   */
  body: string;

  /**
   * @generated from field: int64 at_ms = 5;
   */
  atMs: bigint;

  /**
   * نشانیِ اختیاری (صفحه‌ی رویداد، فروشگاه)
   *
   * @generated from field: string link = 6;
   */
  link: string;
};

/**
 * Describes the message bazivan.v1.Notice.
 * Use `create(NoticeSchema)` to create a new message.
 */
export const NoticeSchema: GenMessage<Notice> = /*@__PURE__*/
  messageDesc(file_bazivan_v1_table, 6);

/**
 * @generated from message bazivan.v1.Hello
 */
export type Hello = Message<"bazivan.v1.Hello"> & {
  /**
   * JWT از POST /v1/auth/guest
   *
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * نسخه‌ی پروتکل (۱)
   *
   * @generated from field: uint32 protocol = 2;
   */
  protocol: number;

  /**
   * کلیدِ چهره‌ی بازیکن — همان کلیدِ قهرمانِ اپ (player, kalantar, …). سرور آن
   * را به هر صندلی می‌چسباند تا همه — وب و موبایل — یک چهره برای یک نفر ببینند؛
   * پیش‌تر هر کلاینت چهره را از هَشِ شناسه می‌ساخت و هر کس چیزِ دیگری می‌دید.
   *
   * @generated from field: string avatar = 3;
   */
  avatar: string;

  /**
   * سکوی کلاینت: web | android | ios | editor | other.
   *
   * برای پنلِ ادمین است، نه برای بازی: بی این، «چند نفر روی وب‌اند و چند نفر
   * روی گوشی» جوابی ندارد — شناسه‌ی دستگاهِ یونیتی پیشوند ندارد و اندروید از
   * iOS تشخیص‌دادنی نیست. کلاینتِ قدیمی خالی می‌فرستد و «نامعلوم» شمرده
   * می‌شود؛ هیچ‌چیزِ بازی به آن بند نیست.
   *
   * @generated from field: string platform = 4;
   */
  platform: string;
};

/**
 * Describes the message bazivan.v1.Hello.
 * Use `create(HelloSchema)` to create a new message.
 */
export const HelloSchema: GenMessage<Hello> = /*@__PURE__*/
  messageDesc(file_bazivan_v1_table, 7);

/**
 * @generated from message bazivan.v1.Welcome
 */
export type Welcome = Message<"bazivan.v1.Welcome"> & {
  /**
   * @generated from field: string player_id = 1;
   */
  playerId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: uint32 protocol = 3;
   */
  protocol: number;
};

/**
 * Describes the message bazivan.v1.Welcome.
 * Use `create(WelcomeSchema)` to create a new message.
 */
export const WelcomeSchema: GenMessage<Welcome> = /*@__PURE__*/
  messageDesc(file_bazivan_v1_table, 8);

/**
 * موجودیِ سروریِ بازیکن. سرور بی‌درخواست می‌فرستد: یک بار بعدِ Welcome و بعد از
 * هر تغییر (جایزه‌ی میز، ورودی، خرید). کلاینت این را نمایش می‌دهد و خودش حساب
 * نمی‌کند — مرجعِ حقیقت سرور است.
 *
 * @generated from message bazivan.v1.WalletState
 */
export type WalletState = Message<"bazivan.v1.WalletState"> & {
  /**
   * @generated from field: int64 coins = 1;
   */
  coins: bigint;

  /**
   * @generated from field: int64 gems = 2;
   */
  gems: bigint;

  /**
   * دلیلِ آخرین تغییر (match_win, table_entry, …)؛ خالی = عکسِ لحظه‌ای
   *
   * @generated from field: string reason = 3;
   */
  reason: string;

  /**
   * تغییرِ همین پیام، برای انیمیشنِ «+۱۸۰» روی شمارنده
   *
   * @generated from field: int64 delta_coins = 4;
   */
  deltaCoins: bigint;

  /**
   * @generated from field: int64 delta_gems = 5;
   */
  deltaGems: bigint;

  /**
   * سطح و تجربه — کنارِ کیف و نه در پیامِ جدا.
   *
   * هر دو با هم و از یک جا عوض می‌شوند (پایانِ میز)، و کلاینتی که کیف را
   * تازه کند ولی سطح را نه، لحظه‌ای عددهای ناهماهنگ نشان می‌دهد.
   *
   * فیلدهای افزوده‌اند: کلاینتِ قدیمی صفر می‌بیند و همان رفتارِ قبلی را
   * دارد — سطحِ محلیِ خودش را نشان می‌دهد.
   *
   * تجربه‌ی **عمر**
   *
   * @generated from field: int32 xp = 6;
   */
  xp: number;

  /**
   * سطحِ حساب‌شده از xp
   *
   * @generated from field: int32 level = 7;
   */
  level: number;

  /**
   * تجربه‌ی درونِ همین سطح — برای نوار
   *
   * @generated from field: int32 level_xp = 8;
   */
  levelXp: number;

  /**
   * تجربه‌ی لازم برای سطحِ بعد
   *
   * @generated from field: int32 level_need = 9;
   */
  levelNeed: number;

  /**
   * تجربه‌ی همین پیام
   *
   * @generated from field: int32 delta_xp = 10;
   */
  deltaXp: number;

  /**
   * leveled_up: همین پیام سطح را بالا برد؟ لحظه‌ی جشن، و نه چیزی که
   * کلاینت باید از مقایسه‌ی دو عکس حدس بزند.
   *
   * @generated from field: bool leveled_up = 11;
   */
  leveledUp: boolean;
};

/**
 * Describes the message bazivan.v1.WalletState.
 * Use `create(WalletStateSchema)` to create a new message.
 */
export const WalletStateSchema: GenMessage<WalletState> = /*@__PURE__*/
  messageDesc(file_bazivan_v1_table, 9);

/**
 * ClaimOffline: سکه‌ای که بازیکن **آفلاین** برده و کلاینت گزارش می‌کند.
 *
 * سرور سقفِ ۲۴ساعته می‌گذارد و هرچه پذیرفت در WalletState برمی‌گردد — کلاینت
 * باید همان عدد را بنشاند، نه عددِ درخواستی‌اش. ref کلیدِ یکتاییِ همین بسته
 * است تا تلاشِ دوباره دو بار واریز نکند.
 *
 * local_total فقط در **اولین** مطالبه معنا دارد: موجودیِ محلیِ پیش از کیفِ
 * سروری، که یک‌بار و با سقفِ جدا منتقل می‌شود.
 *
 * @generated from message bazivan.v1.ClaimOffline
 */
export type ClaimOffline = Message<"bazivan.v1.ClaimOffline"> & {
  /**
   * @generated from field: int64 coins = 1;
   */
  coins: bigint;

  /**
   * @generated from field: string ref = 2;
   */
  ref: string;

  /**
   * @generated from field: int64 local_total = 3;
   */
  localTotal: bigint;

  /**
   * xp: تجربه‌ای که آفلاین گرفته. سقفِ ۲۴ساعته‌ی خودش را دارد، مثلِ سکه —
   * چون مثلِ سکه حرفِ کلاینت است و هیچ‌جا سنجیده نمی‌شود.
   *
   * @generated from field: int32 xp = 4;
   */
  xp: number;

  /**
   * local_xp: تجربه‌ی **عمرِ** دستگاه، فقط در اولین مطالبه.
   *
   * مثلِ local_total یک‌باره است، ولی برخلافِ آن **جمع نمی‌شود**: سرور
   * بیشینه‌ی این و آنچه خودش دارد را می‌گیرد. جمع‌کردن یعنی کسی که روی دو
   * گوشی بازی کرده، دو برابر سطح بگیرد.
   *
   * @generated from field: int32 local_xp = 5;
   */
  localXp: number;
};

/**
 * Describes the message bazivan.v1.ClaimOffline.
 * Use `create(ClaimOfflineSchema)` to create a new message.
 */
export const ClaimOfflineSchema: GenMessage<ClaimOffline> = /*@__PURE__*/
  messageDesc(file_bazivan_v1_table, 10);

/**
 * SpendCoins: خرجِ سکه در فروشگاهِ بازی (قهرمان، فرش، کارتِ ویژه، نجات، ورودیِ جام).
 *
 * ⚠️ قیمت را کلاینت می‌گوید. سرور فقط موجودی و سقف را می‌سنجد، چون کاتالوگِ
 * قیمت و انبارِ آیتم‌ها هنوز سمتِ کلاینت است. یعنی این پیام «موجودی را یکی
 * نگه می‌دارد»، نه «تقلب را می‌بندد» — بستنش کارِ بردنِ کاتالوگ و انبار به
 * سرور است. item فقط برچسبِ دفتر است و سرور با آن تصمیمی نمی‌گیرد.
 *
 * @generated from message bazivan.v1.SpendCoins
 */
export type SpendCoins = Message<"bazivan.v1.SpendCoins"> & {
  /**
   * @generated from field: int64 coins = 1;
   */
  coins: bigint;

  /**
   * @generated from field: string item = 2;
   */
  item: string;

  /**
   * @generated from field: string ref = 3;
   */
  ref: string;
};

/**
 * Describes the message bazivan.v1.SpendCoins.
 * Use `create(SpendCoinsSchema)` to create a new message.
 */
export const SpendCoinsSchema: GenMessage<SpendCoins> = /*@__PURE__*/
  messageDesc(file_bazivan_v1_table, 11);

/**
 * BuyItem: خریدِ قلمِ فروشگاه. **بها را کلاینت نمی‌فرستد** — سرور از کاتالوگِ
 * خودش برمی‌دارد. جوابِ موفق: InventoryState + WalletState.
 * جوابِ ناموفق: Error با کدِ insufficient_coins | unknown_item | already_owned.
 *
 * @generated from message bazivan.v1.BuyItem
 */
export type BuyItem = Message<"bazivan.v1.BuyItem"> & {
  /**
   * @generated from field: string item = 1;
   */
  item: string;

  /**
   * کلیدِ یکتاییِ تلاش، تا تکرارِ شبکه دو بار نخرد
   *
   * @generated from field: string ref = 2;
   */
  ref: string;
};

/**
 * Describes the message bazivan.v1.BuyItem.
 * Use `create(BuyItemSchema)` to create a new message.
 */
export const BuyItemSchema: GenMessage<BuyItem> = /*@__PURE__*/
  messageDesc(file_bazivan_v1_table, 12);

/**
 * InventoryState: انبارِ بازیکن. بعدِ Welcome و بعدِ هر خرید فرستاده می‌شود.
 *
 * @generated from message bazivan.v1.InventoryState
 */
export type InventoryState = Message<"bazivan.v1.InventoryState"> & {
  /**
   * @generated from field: repeated bazivan.v1.OwnedItem items = 1;
   */
  items: OwnedItem[];
};

/**
 * Describes the message bazivan.v1.InventoryState.
 * Use `create(InventoryStateSchema)` to create a new message.
 */
export const InventoryStateSchema: GenMessage<InventoryState> = /*@__PURE__*/
  messageDesc(file_bazivan_v1_table, 13);

/**
 * @generated from message bazivan.v1.OwnedItem
 */
export type OwnedItem = Message<"bazivan.v1.OwnedItem"> & {
  /**
   * @generated from field: string item = 1;
   */
  item: string;

  /**
   * @generated from field: uint32 qty = 2;
   */
  qty: number;
};

/**
 * Describes the message bazivan.v1.OwnedItem.
 * Use `create(OwnedItemSchema)` to create a new message.
 */
export const OwnedItemSchema: GenMessage<OwnedItem> = /*@__PURE__*/
  messageDesc(file_bazivan_v1_table, 14);

/**
 * SubscriptionState: وضعیتِ اشتراکِ ماهانه. بعدِ Welcome و بعد از هر
 * تغییر فرستاده می‌شود.
 * StartTrial: هفت روزِ رایگانِ «اشتراکِ ماهانه»، یک بار برای هر حساب.
 *
 * رسید نمی‌خواهد و همین حالا کار می‌کند — تنها بخشی از اشتراک که به فروشگاه
 * بند نیست. جواب: SubscriptionState، یا Error با کدِ trial_used.
 *
 * @generated from message bazivan.v1.StartTrial
 */
export type StartTrial = Message<"bazivan.v1.StartTrial"> & {
};

/**
 * Describes the message bazivan.v1.StartTrial.
 * Use `create(StartTrialSchema)` to create a new message.
 */
export const StartTrialSchema: GenMessage<StartTrial> = /*@__PURE__*/
  messageDesc(file_bazivan_v1_table, 15);

/**
 * @generated from message bazivan.v1.SubscriptionState
 */
export type SubscriptionState = Message<"bazivan.v1.SubscriptionState"> & {
  /**
   * @generated from field: bool active = 1;
   */
  active: boolean;

  /**
   * زمانِ یونیکس؛ ۰ یعنی هرگز اشتراکی نبوده
   *
   * @generated from field: int64 expires_at_ms = 2;
   */
  expiresAtMs: bigint;

  /**
   * دوره‌ی آزمایشی مصرف شده؟ (برای دکمه‌ی «۷ روز رایگان»)
   *
   * @generated from field: bool trial_used = 3;
   */
  trialUsed: boolean;

  /**
   * گوهرِ روزانه‌ی همین پله
   *
   * @generated from field: int64 daily_gems = 4;
   */
  dailyGems: bigint;

  /**
   * ضریبِ سکه‌ی میزِ رایگان
   *
   * @generated from field: int64 coin_multiplier = 5;
   */
  coinMultiplier: bigint;
};

/**
 * Describes the message bazivan.v1.SubscriptionState.
 * Use `create(SubscriptionStateSchema)` to create a new message.
 */
export const SubscriptionStateSchema: GenMessage<SubscriptionState> = /*@__PURE__*/
  messageDesc(file_bazivan_v1_table, 16);

/**
 * @generated from message bazivan.v1.Error
 */
export type Error = Message<"bazivan.v1.Error"> & {
  /**
   * e.g. "unauthorized", "not_your_turn", "illegal_card"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * متنِ انگلیسیِ دیباگ؛ کلاینت با code متنِ فارسی می‌سازد
   *
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * Describes the message bazivan.v1.Error.
 * Use `create(ErrorSchema)` to create a new message.
 */
export const ErrorSchema: GenMessage<Error> = /*@__PURE__*/
  messageDesc(file_bazivan_v1_table, 17);

/**
 * @generated from message bazivan.v1.Ping
 */
export type Ping = Message<"bazivan.v1.Ping"> & {
};

/**
 * Describes the message bazivan.v1.Ping.
 * Use `create(PingSchema)` to create a new message.
 */
export const PingSchema: GenMessage<Ping> = /*@__PURE__*/
  messageDesc(file_bazivan_v1_table, 18);

/**
 * @generated from message bazivan.v1.Pong
 */
export type Pong = Message<"bazivan.v1.Pong"> & {
  /**
   * @generated from field: int64 server_time_ms = 1;
   */
  serverTimeMs: bigint;
};

/**
 * Describes the message bazivan.v1.Pong.
 * Use `create(PongSchema)` to create a new message.
 */
export const PongSchema: GenMessage<Pong> = /*@__PURE__*/
  messageDesc(file_bazivan_v1_table, 19);

/**
 * QuickMatch: صفِ بازیِ سریع.
 *
 * stake: ورودیِ سکه‌ایِ میزی که می‌خواهی — فقط سطح‌های مجاز (۱۰۰/۵۰۰/۲۰۰۰)؛
 * هر عددِ دیگری یعنی میزِ رایگان. صف به ازای **هر سطح جداست**: کسی که ۲۰۰۰
 * گذاشته نباید سرِ میزی بنشیند که بقیه ۱۰۰ داده‌اند.
 *
 * و همان خطِ قرمزِ همیشگی این‌جا هم هست: اگر صندلی‌ها با ربات پر شوند، میز
 * رایگان می‌شود و از کسی چیزی برداشته نمی‌شود — [[economy.StakeAllowed]].
 * QuickMatch: صف بگیر، یا با `solo` مستقیم میزی با ربات‌ها.
 *
 * solo از صف نمی‌گذرد و ورودیِ سکه‌ای هم ندارد: حریفش ربات است و پولِ کسی
 * وسط نیست. بازی‌ای که ادمین از آنلاین درآورده فقط همین راه را دارد، و سرور
 * درخواستِ غیرِsoloِ آن را خودش به solo می‌بَرد تا کلاینتِ قدیمی پشتِ صفی که
 * هیچ‌وقت پر نمی‌شود نمانَد.
 *
 * @generated from message bazivan.v1.QuickMatch
 */
export type QuickMatch = Message<"bazivan.v1.QuickMatch"> & {
  /**
   * @generated from field: string game = 1;
   */
  game: string;

  /**
   * @generated from field: int64 stake = 2;
   */
  stake: bigint;

  /**
   * @generated from field: bool solo = 3;
   */
  solo: boolean;
};

/**
 * Describes the message bazivan.v1.QuickMatch.
 * Use `create(QuickMatchSchema)` to create a new message.
 */
export const QuickMatchSchema: GenMessage<QuickMatch> = /*@__PURE__*/
  messageDesc(file_bazivan_v1_table, 20);

/**
 * @generated from message bazivan.v1.CancelMatch
 */
export type CancelMatch = Message<"bazivan.v1.CancelMatch"> & {
};

/**
 * Describes the message bazivan.v1.CancelMatch.
 * Use `create(CancelMatchSchema)` to create a new message.
 */
export const CancelMatchSchema: GenMessage<CancelMatch> = /*@__PURE__*/
  messageDesc(file_bazivan_v1_table, 21);

/**
 * @generated from message bazivan.v1.MatchStatus
 */
export type MatchStatus = Message<"bazivan.v1.MatchStatus"> & {
  /**
   * "searching" | "found" | "cancelled"
   *
   * @generated from field: string state = 1;
   */
  state: string;

  /**
   * چند نفر واقعی نشسته‌اند
   *
   * @generated from field: uint32 seated = 2;
   */
  seated: number;

  /**
   * @generated from field: uint32 seats = 3;
   */
  seats: number;

  /**
   * چند ثانیه تا پرشدن با ربات
   *
   * @generated from field: uint32 bot_fill_in_sec = 4;
   */
  botFillInSec: number;

  /**
   * @generated from field: string table_id = 5;
   */
  tableId: string;
};

/**
 * Describes the message bazivan.v1.MatchStatus.
 * Use `create(MatchStatusSchema)` to create a new message.
 */
export const MatchStatusSchema: GenMessage<MatchStatus> = /*@__PURE__*/
  messageDesc(file_bazivan_v1_table, 22);

/**
 * stake: ورودیِ سکه‌ایِ هر بازیکن — فقط سطح‌های مجاز (۱۰۰/۵۰۰/۲۰۰۰)؛ هر عددِ
 * دیگری یعنی میزِ رایگان. میزِ ورودی‌دار با ربات ساخته نمی‌شود.
 * is_public: میزِ این اتاق در فهرستِ تماشا بیاید؟ اتاقِ کددار پیش‌فرض خصوصی
 * است — دو دوستی که با کد بازی می‌کنند نباید بی‌آن‌که بخواهند پخش شوند.
 * password: رمزِ اختیاریِ اتاق (خالی = بی‌رمز). کدِ شش‌رقمی دستِ چند نفر
 * می‌چرخد و گاهی جایی نوشته می‌شود؛ رمز برای میزبانی است که می‌خواهد مطمئن
 * باشد فقط همان‌ها می‌نشینند. سرور فقط هشش را نگه می‌دارد و با بسته‌شدنِ اتاق
 * می‌رود.
 *
 * @generated from message bazivan.v1.CreateRoom
 */
export type CreateRoom = Message<"bazivan.v1.CreateRoom"> & {
  /**
   * @generated from field: string game = 1;
   */
  game: string;

  /**
   * @generated from field: uint32 seats = 2;
   */
  seats: number;

  /**
   * @generated from field: string carpet = 3;
   */
  carpet: string;

  /**
   * @generated from field: int64 stake = 4;
   */
  stake: bigint;

  /**
   * @generated from field: bool is_public = 5;
   */
  isPublic: boolean;

  /**
   * @generated from field: string password = 6;
   */
  password: string;
};

/**
 * Describes the message bazivan.v1.CreateRoom.
 * Use `create(CreateRoomSchema)` to create a new message.
 */
export const CreateRoomSchema: GenMessage<CreateRoom> = /*@__PURE__*/
  messageDesc(file_bazivan_v1_table, 23);

/**
 * میزِ اتاق را عمومی/خصوصی کن — فقط میزبان، پیش از شروع. بعد از شروع کاری نمی‌کند:
 * میزی که پخش شده نباید وسطِ دست از چشمِ تماشاچی غیب شود.
 *
 * @generated from message bazivan.v1.SetPublic
 */
export type SetPublic = Message<"bazivan.v1.SetPublic"> & {
  /**
   * @generated from field: bool is_public = 1;
   */
  isPublic: boolean;
};

/**
 * Describes the message bazivan.v1.SetPublic.
 * Use `create(SetPublicSchema)` to create a new message.
 */
export const SetPublicSchema: GenMessage<SetPublic> = /*@__PURE__*/
  messageDesc(file_bazivan_v1_table, 24);

/**
 * فرشِ میز را عوض کن — فقط میزبان، در اتاق. کلیدها: eyvan | lajvard | mahoot | gelim | shab.
 *
 * @generated from message bazivan.v1.SetCarpet
 */
export type SetCarpet = Message<"bazivan.v1.SetCarpet"> & {
  /**
   * @generated from field: string carpet = 1;
   */
  carpet: string;
};

/**
 * Describes the message bazivan.v1.SetCarpet.
 * Use `create(SetCarpetSchema)` to create a new message.
 */
export const SetCarpetSchema: GenMessage<SetCarpet> = /*@__PURE__*/
  messageDesc(file_bazivan_v1_table, 25);

/**
 * password: اگر اتاق رمز داشته باشد. بی آن، سرور خطای room_password می‌دهد و
 * کلاینت همان‌جا رمز می‌پرسد — نه این‌که از اول از همه رمز بخواهد.
 *
 * @generated from message bazivan.v1.JoinRoom
 */
export type JoinRoom = Message<"bazivan.v1.JoinRoom"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string password = 2;
   */
  password: string;
};

/**
 * Describes the message bazivan.v1.JoinRoom.
 * Use `create(JoinRoomSchema)` to create a new message.
 */
export const JoinRoomSchema: GenMessage<JoinRoom> = /*@__PURE__*/
  messageDesc(file_bazivan_v1_table, 26);

/**
 * @generated from message bazivan.v1.LeaveRoom
 */
export type LeaveRoom = Message<"bazivan.v1.LeaveRoom"> & {
};

/**
 * Describes the message bazivan.v1.LeaveRoom.
 * Use `create(LeaveRoomSchema)` to create a new message.
 */
export const LeaveRoomSchema: GenMessage<LeaveRoom> = /*@__PURE__*/
  messageDesc(file_bazivan_v1_table, 27);

/**
 * @generated from message bazivan.v1.StartRoom
 */
export type StartRoom = Message<"bazivan.v1.StartRoom"> & {
};

/**
 * Describes the message bazivan.v1.StartRoom.
 * Use `create(StartRoomSchema)` to create a new message.
 */
export const StartRoomSchema: GenMessage<StartRoom> = /*@__PURE__*/
  messageDesc(file_bazivan_v1_table, 28);

/**
 * @generated from message bazivan.v1.RoomState
 */
export type RoomState = Message<"bazivan.v1.RoomState"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string game = 2;
   */
  game: string;

  /**
   * @generated from field: string host_id = 3;
   */
  hostId: string;

  /**
   * @generated from field: repeated bazivan.v1.Seat seats = 4;
   */
  seats: Seat[];

  /**
   * @generated from field: bool started = 5;
   */
  started: boolean;

  /**
   * @generated from field: string table_id = 6;
   */
  tableId: string;

  /**
   * فرشِ این اتاق — همه همین را می‌بینند
   *
   * @generated from field: string carpet = 7;
   */
  carpet: string;

  /**
   * ورودیِ هر بازیکن؛ ۰ = رایگان
   *
   * @generated from field: int64 stake = 8;
   */
  stake: bigint;

  /**
   * میزش در فهرستِ تماشا می‌آید؟ (انتخابِ میزبان)
   *
   * @generated from field: bool is_public = 9;
   */
  isPublic: boolean;

  /**
   * چتِ میز باز است؟ (پیش‌فرض بله؛ میزبان می‌بندد)
   *
   * @generated from field: bool chat_open = 10;
   */
  chatOpen: boolean;

  /**
   * اتاق رمز دارد؟ (خودِ رمز هیچ‌وقت بیرون نمی‌رود)
   *
   * @generated from field: bool locked = 11;
   */
  locked: boolean;
};

/**
 * Describes the message bazivan.v1.RoomState.
 * Use `create(RoomStateSchema)` to create a new message.
 */
export const RoomStateSchema: GenMessage<RoomState> = /*@__PURE__*/
  messageDesc(file_bazivan_v1_table, 29);

/**
 * @generated from message bazivan.v1.Seat
 */
export type Seat = Message<"bazivan.v1.Seat"> & {
  /**
   * @generated from field: uint32 index = 1;
   */
  index: number;

  /**
   * خالی = صندلیِ خالی
   *
   * @generated from field: string player_id = 2;
   */
  playerId: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: bool bot = 4;
   */
  bot: boolean;

  /**
   * @generated from field: bool connected = 5;
   */
  connected: boolean;

  /**
   * کلیدِ چهره — از Hello، برای ربات از سرور
   *
   * @generated from field: string avatar = 6;
   */
  avatar: string;

  /**
   * نشانِ «اشتراکِ ماهانه». عکسِ لحظه‌ی نشستن است و نه زنده: سرور وضعیت را سرِ
   * چیدنِ صندلی می‌خوانَد، وگرنه هر ساختِ نما یک پرس‌وجوی دیتابیس می‌شد و
   * نما در هر حرکت ساخته می‌شود.
   *
   * @generated from field: bool subscriber = 7;
   */
  subscriber: boolean;

  /**
   * کشور و شهر — اختیاری، از خودِ بازیکن (نه IP)، و فقط اگر خودش «نشان بده» را
   * روشن کرده باشد؛ وگرنه خالی. country کدِ دوحرفیِ ISO است، city نامِ فارسیِ
   * شهر از فهرستِ شهرهای ایران (فقط وقتی country == "IR").
   *
   * @generated from field: string country = 8;
   */
  country: string;

  /**
   * @generated from field: string city = 9;
   */
  city: string;

  /**
   * Back: کلیدِ پشتِ کارتِ این بازیکن — از **سرور** و نه از Hello.
   *
   * فرش مالِ میز است و یکی؛ پشتِ کارت شخصی است: ورق‌های هر کس با پشتِ
   * خودش دیده می‌شود. از سرور می‌آید چون باید داشته باشدش (خریده باشد) و
   * چون باید روی هر دستگاهی یکی باشد. خالی = پشتِ پیش‌فرض.
   *
   * @generated from field: string back = 10;
   */
  back: string;
};

/**
 * Describes the message bazivan.v1.Seat.
 * Use `create(SeatSchema)` to create a new message.
 */
export const SeatSchema: GenMessage<Seat> = /*@__PURE__*/
  messageDesc(file_bazivan_v1_table, 30);

/**
 * @generated from message bazivan.v1.CallTrump
 */
export type CallTrump = Message<"bazivan.v1.CallTrump"> & {
  /**
   * @generated from field: bazivan.v1.Suit suit = 1;
   */
  suit: Suit;
};

/**
 * Describes the message bazivan.v1.CallTrump.
 * Use `create(CallTrumpSchema)` to create a new message.
 */
export const CallTrumpSchema: GenMessage<CallTrump> = /*@__PURE__*/
  messageDesc(file_bazivan_v1_table, 31);

/**
 * @generated from message bazivan.v1.PlayCard
 */
export type PlayCard = Message<"bazivan.v1.PlayCard"> & {
  /**
   * @generated from field: bazivan.v1.Card card = 1;
   */
  card?: Card | undefined;
};

/**
 * Describes the message bazivan.v1.PlayCard.
 * Use `create(PlayCardSchema)` to create a new message.
 */
export const PlayCardSchema: GenMessage<PlayCard> = /*@__PURE__*/
  messageDesc(file_bazivan_v1_table, 32);

/**
 * نمای میز از چشمِ یک صندلی: فقط دستِ خودش، شمارِ کارتِ بقیه.
 *
 * @generated from message bazivan.v1.TableState
 */
export type TableState = Message<"bazivan.v1.TableState"> & {
  /**
   * @generated from field: string table_id = 1;
   */
  tableId: string;

  /**
   * @generated from field: string game = 2;
   */
  game: string;

  /**
   * صندلیِ من
   *
   * @generated from field: uint32 me = 3;
   */
  me: number;

  /**
   * @generated from field: repeated bazivan.v1.Seat seats = 4;
   */
  seats: Seat[];

  /**
   * @generated from field: repeated bazivan.v1.Card my_hand = 5;
   */
  myHand: Card[];

  /**
   * به ایندکسِ صندلی
   *
   * @generated from field: repeated uint32 hand_counts = 6;
   */
  handCounts: number[];

  /**
   * @generated from field: uint32 hakem = 7;
   */
  hakem: number;

  /**
   * @generated from field: bool trump_chosen = 8;
   */
  trumpChosen: boolean;

  /**
   * @generated from field: bazivan.v1.Suit trump = 9;
   */
  trump: Suit;

  /**
   * صندلیِ نوبت‌دار
   *
   * @generated from field: uint32 turn = 10;
   */
  turn: number;

  /**
   * @generated from field: uint32 leader = 11;
   */
  leader: number;

  /**
   * @generated from field: repeated bazivan.v1.TrickCard trick = 12;
   */
  trick: TrickCard[];

  /**
   * به ازای هر واحد (تیم)
   *
   * @generated from field: repeated uint32 tricks_won = 13;
   */
  tricksWon: number[];

  /**
   * امتیازِ مسابقه به ازای هر واحد
   *
   * @generated from field: repeated uint32 score = 14;
   */
  score: number[];

  /**
   * حاکم باید حکم بخواند
   *
   * @generated from field: bool awaiting_trump = 15;
   */
  awaitingTrump: boolean;

  /**
   * مهلتِ نوبت (زمانِ سرور، میلی‌ثانیه)
   *
   * @generated from field: uint32 turn_deadline_ms = 16;
   */
  turnDeadlineMs: number;

  /**
   * @generated from field: bool hand_over = 17;
   */
  handOver: boolean;

  /**
   * @generated from field: bool match_over = 18;
   */
  matchOver: boolean;

  /**
   * @generated from field: uint32 match_target = 19;
   */
  matchTarget: number;

  /**
   * @generated from field: int64 server_time_ms = 20;
   */
  serverTimeMs: bigint;

  /**
   * چند دست تا بردِ یک دور. قاعده است (۶ نفره ۵، بقیه ۷) و قاعده دستِ سرور
   * است؛ کلاینت فقط همین‌قدر نقطه می‌کشد و خودش حساب نمی‌کند.
   *
   * @generated from field: uint32 tricks_to_win = 21;
   */
  tricksToWin: number;

  /**
   * واحدِ (تیمِ) هر صندلی — برای این‌که کلاینت نخواهد `seat % 2` را از نو بنویسد.
   *
   * @generated from field: repeated uint32 seat_unit = 22;
   */
  seatUnit: number[];

  /**
   * فرشِ میز — یکی برای همه‌ی صندلی‌ها
   *
   * @generated from field: string carpet = 23;
   */
  carpet: string;

  /**
   * watching: این نما مالِ تماشاچی است، نه بازیکن. آن‌وقت my_hand خالی است و
   * me فقط لنگرِ چرخشِ صندلی‌هاست (۰)، نه «من». کلاینت باید دستِ پایینِ صفحه را
   * هم پشت‌ورو بکشد و هیچ لمسی را به سرور نفرستد.
   *
   * @generated from field: bool watching = 24;
   */
  watching: boolean;

  /**
   * چند نفر دارند تماشا می‌کنند (بازیکن هم می‌بیند)
   *
   * @generated from field: uint32 watchers = 25;
   */
  watchers: number;

  /**
   * چتِ این میز باز است؟ (میزبان می‌بندد)
   *
   * @generated from field: bool chat_open = 26;
   */
  chatOpen: boolean;

  /**
   * host: منِ گیرنده‌ی این نما میزبانِ اتاقی‌ام که این میز از آن آمده؟
   *
   * در خودِ نما می‌آید و نه از روی اتاق، چون اتاق با شروعِ بازی می‌رود و
   * بازگشت از قطعی هیچ‌وقت آن را دوباره نمی‌بیند: بی این، میزبانی که صفحه‌اش
   * را تازه کرده بود دیگر نمی‌توانست چت را ببندد.
   *
   * @generated from field: bool host = 27;
   */
  host: boolean;

  /**
   * v: شماره‌ی یکنواختِ میز در لحظه‌ی ساختنِ این پیام.
   *
   * هر میز یک شمارنده دارد که با هر پخشِ وضعیت و هر رویداد یکی جلو می‌رود.
   * کلاینت آخرین `v`ِ اعمال‌شده را نگه می‌دارد و هرچه کوچک‌تر یا مساوی باشد
   * دور می‌ریزد. چرا لازم است با وجودِ ترتیبِ تضمین‌شده‌ی TCP: پیام‌ها به‌ترتیب
   * *می‌رسند* ولی همیشه به‌ترتیب *اعمال* نمی‌شوند — سوکتِ کهنه‌ای که هنوز
   * نمرده فریم می‌دهد، و کلاینت گاهی پشتِ یک await وضعیت را دیر می‌نشانَد.
   * آن‌وقت عکسِ کهنه روی تازه می‌نشیند و میز عقب می‌پرد.
   *
   * @generated from field: uint64 v = 28;
   */
  v: bigint;

  /**
   * stake: ورودیِ سکه‌ایِ هر بازیکن که سرِ شروعِ همین میز برداشته شد؛ ۰ = رایگان.
   *
   * در **نمای میز** می‌آید و نه فقط در اتاق، چون پرده‌ی شرط باید هر جوری که
   * بازیکن سرِ میز رسیده بالا بیاید: بازیِ سریع اتاقی ندارد، بازگشت از قطعی
   * اتاق را دیگر نمی‌بیند، و تماشاچی اصلاً در اتاق نبوده. عددِ *واقعیِ*
   * برداشت‌شده است و نه خواسته‌ی اتاق — میزی که یکی‌شان پول نداشت رایگان
   * می‌شود و آن‌وقت نباید پرده‌ی شرط بالا بیاید.
   *
   * @generated from field: int64 stake = 29;
   */
  stake: bigint;
};

/**
 * Describes the message bazivan.v1.TableState.
 * Use `create(TableStateSchema)` to create a new message.
 */
export const TableStateSchema: GenMessage<TableState> = /*@__PURE__*/
  messageDesc(file_bazivan_v1_table, 33);

/**
 * @generated from message bazivan.v1.TrickCard
 */
export type TrickCard = Message<"bazivan.v1.TrickCard"> & {
  /**
   * @generated from field: uint32 seat = 1;
   */
  seat: number;

  /**
   * @generated from field: bazivan.v1.Card card = 2;
   */
  card?: Card | undefined;
};

/**
 * Describes the message bazivan.v1.TrickCard.
 * Use `create(TrickCardSchema)` to create a new message.
 */
export const TrickCardSchema: GenMessage<TrickCard> = /*@__PURE__*/
  messageDesc(file_bazivan_v1_table, 34);

/**
 * رویدادهای لحظه‌ای برای انیمیشن؛ وضعیتِ کامل همیشه با TableState می‌آید.
 *
 * @generated from message bazivan.v1.TableEvent
 */
export type TableEvent = Message<"bazivan.v1.TableEvent"> & {
  /**
   * "ace_draw" | "trump_called" | "card_played" | "trick_won" | "hand_over" | "match_over" | "seat_bot" | "seat_reconnect"
   *
   * @generated from field: string kind = 1;
   */
  kind: string;

  /**
   * @generated from field: uint32 seat = 2;
   */
  seat: number;

  /**
   * @generated from field: bazivan.v1.Card card = 3;
   */
  card?: Card | undefined;

  /**
   * @generated from field: bazivan.v1.Suit suit = 4;
   */
  suit: Suit;

  /**
   * @generated from field: uint32 winner_unit = 5;
   */
  winnerUnit: number;

  /**
   * @generated from field: uint32 points = 6;
   */
  points: number;

  /**
   * @generated from field: bool kot = 7;
   */
  kot: boolean;

  /**
   * @generated from field: bool hakem_kot = 8;
   */
  hakemKot: boolean;

  /**
   * آس‌کشیِ آغازِ مسابقه ("ace_draw"): ورق‌ها به ترتیبِ رو‌شدن، از `from_seat`
   * دور می‌چرخند و آخری آس است. `seat` صندلیِ حاکم است. قرعه دستِ سرور می‌مانَد؛
   * این‌ها فقط برای نمایش‌اند تا بازیکن ببیند چرا این نفر حاکم شد.
   *
   * @generated from field: repeated bazivan.v1.Card draw = 9;
   */
  draw: Card[];

  /**
   * @generated from field: uint32 from_seat = 10;
   */
  fromSeat: number;

  /**
   * v: شماره‌ی میز در لحظه‌ی این رویداد — [[TableState.v]].
   *
   * رویداد فقط نشانه‌ی انیمیشن است، پس دوباره‌فرستادنی نیست: اگر `v`ِ آن از
   * آخرین وضعیتِ اعمال‌شده عقب‌تر باشد، انیمیشنش مالِ گذشته است و باید
   * نادیده برود، نه این‌که کارتی را که همین حالا سرِ جایش است دوباره بپرانَد.
   *
   * @generated from field: uint64 v = 11;
   */
  v: bigint;
};

/**
 * Describes the message bazivan.v1.TableEvent.
 * Use `create(TableEventSchema)` to create a new message.
 */
export const TableEventSchema: GenMessage<TableEvent> = /*@__PURE__*/
  messageDesc(file_bazivan_v1_table, 35);

/**
 * ListTables: میزهای عمومیِ زنده را بده. game خالی = همه.
 *
 * @generated from message bazivan.v1.ListTables
 */
export type ListTables = Message<"bazivan.v1.ListTables"> & {
  /**
   * @generated from field: string game = 1;
   */
  game: string;
};

/**
 * Describes the message bazivan.v1.ListTables.
 * Use `create(ListTablesSchema)` to create a new message.
 */
export const ListTablesSchema: GenMessage<ListTables> = /*@__PURE__*/
  messageDesc(file_bazivan_v1_table, 36);

/**
 * یک میزِ زنده، آن‌طور که از بیرون پیداست: چه کسانی نشسته‌اند و چند نفر
 * تماشا می‌کنند. دستِ هیچ‌کس این‌جا نیست و نباید باشد.
 *
 * @generated from message bazivan.v1.PublicTable
 */
export type PublicTable = Message<"bazivan.v1.PublicTable"> & {
  /**
   * @generated from field: string table_id = 1;
   */
  tableId: string;

  /**
   * @generated from field: string game = 2;
   */
  game: string;

  /**
   * @generated from field: repeated bazivan.v1.Seat seats = 3;
   */
  seats: Seat[];

  /**
   * @generated from field: uint32 watchers = 4;
   */
  watchers: number;

  /**
   * @generated from field: int64 stake = 5;
   */
  stake: bigint;

  /**
   * @generated from field: string carpet = 6;
   */
  carpet: string;

  /**
   * زمانِ شروع (یونیکس، میلی‌ثانیه) — برای «۴ دقیقه است»
   *
   * @generated from field: int64 started_at_ms = 7;
   */
  startedAtMs: bigint;
};

/**
 * Describes the message bazivan.v1.PublicTable.
 * Use `create(PublicTableSchema)` to create a new message.
 */
export const PublicTableSchema: GenMessage<PublicTable> = /*@__PURE__*/
  messageDesc(file_bazivan_v1_table, 37);

/**
 * @generated from message bazivan.v1.TableList
 */
export type TableList = Message<"bazivan.v1.TableList"> & {
  /**
   * @generated from field: repeated bazivan.v1.PublicTable tables = 1;
   */
  tables: PublicTable[];
};

/**
 * Describes the message bazivan.v1.TableList.
 * Use `create(TableListSchema)` to create a new message.
 */
export const TableListSchema: GenMessage<TableList> = /*@__PURE__*/
  messageDesc(file_bazivan_v1_table, 38);

/**
 * WatchTable: تماشاچی شو. صندلی نمی‌گیری و در بازی دخالتی نداری؛ همان
 * وضعیت‌ها و رویدادهای میز می‌آید، ولی با my_hand خالی و watching روشن.
 *
 * **دستِ هیچ‌کس دیده نمی‌شود** — نه دستِ خودت، نه دستِ بازیکن‌ها. تماشاچی‌ای که
 * دستِ حریف را ببیند، می‌تواند کنارِ رفیقش بنشیند و بازی را برایش ببرد؛ بعدش
 * هیچ میزِ ورودی‌داری قابلِ اعتماد نیست.
 *
 * @generated from message bazivan.v1.WatchTable
 */
export type WatchTable = Message<"bazivan.v1.WatchTable"> & {
  /**
   * @generated from field: string table_id = 1;
   */
  tableId: string;
};

/**
 * Describes the message bazivan.v1.WatchTable.
 * Use `create(WatchTableSchema)` to create a new message.
 */
export const WatchTableSchema: GenMessage<WatchTable> = /*@__PURE__*/
  messageDesc(file_bazivan_v1_table, 39);

/**
 * @generated from message bazivan.v1.StopWatch
 */
export type StopWatch = Message<"bazivan.v1.StopWatch"> & {
};

/**
 * Describes the message bazivan.v1.StopWatch.
 * Use `create(StopWatchSchema)` to create a new message.
 */
export const StopWatchSchema: GenMessage<StopWatch> = /*@__PURE__*/
  messageDesc(file_bazivan_v1_table, 40);

/**
 * SendChat: پیام روی چتِ میز — یک چت برای بازیکن و تماشاچی، مثلِ پخشِ زنده.
 *
 * یا `text` پر است یا `canned`. عبارتِ آماده کلید می‌فرستد و نه متن، تا هر
 * کلاینت آن را به زبانِ خودش نشان دهد و سرور هم متنی را که نساخته پخش نکند.
 *
 * @generated from message bazivan.v1.SendChat
 */
export type SendChat = Message<"bazivan.v1.SendChat"> & {
  /**
   * متنِ آزاد؛ سرور می‌بُرد، پاک می‌کند و فحش را می‌پوشاند
   *
   * @generated from field: string text = 1;
   */
  text: string;

  /**
   * کلیدِ عبارتِ آماده (bravo, nice_move, …)؛ پر باشد، text نادیده می‌رود
   *
   * @generated from field: string canned = 2;
   */
  canned: string;
};

/**
 * Describes the message bazivan.v1.SendChat.
 * Use `create(SendChatSchema)` to create a new message.
 */
export const SendChatSchema: GenMessage<SendChat> = /*@__PURE__*/
  messageDesc(file_bazivan_v1_table, 41);

/**
 * ChatMessage: پیامی که سرور به همه‌ی میز پخش می‌کند.
 *
 * نام و چهره همراهِ پیام می‌روند و نه فقط شناسه: تماشاچی در صندلی‌های میز
 * نیست، پس کلاینت نمی‌تواند از روی seats پیدایش کند.
 *
 * @generated from message bazivan.v1.ChatMessage
 */
export type ChatMessage = Message<"bazivan.v1.ChatMessage"> & {
  /**
   * @generated from field: string player_id = 1;
   */
  playerId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string avatar = 3;
   */
  avatar: string;

  /**
   * صندلیِ فرستنده؛ ‎-۱ = تماشاچی
   *
   * @generated from field: int32 seat = 4;
   */
  seat: number;

  /**
   * متنِ آزادِ پاک‌شده (برای عبارتِ آماده خالی است)
   *
   * @generated from field: string text = 5;
   */
  text: string;

  /**
   * کلیدِ عبارتِ آماده
   *
   * @generated from field: string canned = 6;
   */
  canned: string;

  /**
   * @generated from field: int64 at_ms = 7;
   */
  atMs: bigint;

  /**
   * @generated from field: bool subscriber = 8;
   */
  subscriber: boolean;
};

/**
 * Describes the message bazivan.v1.ChatMessage.
 * Use `create(ChatMessageSchema)` to create a new message.
 */
export const ChatMessageSchema: GenMessage<ChatMessage> = /*@__PURE__*/
  messageDesc(file_bazivan_v1_table, 42);

/**
 * ChatHistory: چند پیامِ آخرِ میز، سرِ نشستن یا سرِ شروعِ تماشا — تا صفحه‌ی
 * تازه‌وارد خالی نمانَد و بفهمد وسطِ چه حرفی رسیده.
 *
 * @generated from message bazivan.v1.ChatHistory
 */
export type ChatHistory = Message<"bazivan.v1.ChatHistory"> & {
  /**
   * @generated from field: repeated bazivan.v1.ChatMessage messages = 1;
   */
  messages: ChatMessage[];
};

/**
 * Describes the message bazivan.v1.ChatHistory.
 * Use `create(ChatHistorySchema)` to create a new message.
 */
export const ChatHistorySchema: GenMessage<ChatHistory> = /*@__PURE__*/
  messageDesc(file_bazivan_v1_table, 43);

/**
 * SetChatOpen: چتِ میز را باز یا بسته کن — فقط میزبانِ اتاق، چه پیش از شروع و
 * چه وسطِ بازی. وسطِ بازی همان لحظه‌ای است که واقعاً لازم می‌شود.
 *
 * @generated from message bazivan.v1.SetChatOpen
 */
export type SetChatOpen = Message<"bazivan.v1.SetChatOpen"> & {
  /**
   * @generated from field: bool open = 1;
   */
  open: boolean;
};

/**
 * Describes the message bazivan.v1.SetChatOpen.
 * Use `create(SetChatOpenSchema)` to create a new message.
 */
export const SetChatOpenSchema: GenMessage<SetChatOpen> = /*@__PURE__*/
  messageDesc(file_bazivan_v1_table, 44);

/**
 * Resync: عکسِ تازه‌ی میز را بده.
 *
 * روی همان سوکت و نه یک کالِ HTTP: پاسخِ HTTP از کانالِ دیگری می‌آید و
 * می‌تواند دیرتر از وضعیتِ بعدیِ سوکت برسد — یعنی همان «کهنه روی تازه» که
 * `v` برای بستنش آمده. این‌جا پاسخ در همان صفِ مرتب می‌نشیند و `v`ِ خودش را
 * دارد، پس بی‌خطر است حتی اگر چند بار پشتِ هم خواسته شود.
 *
 * @generated from message bazivan.v1.Resync
 */
export type Resync = Message<"bazivan.v1.Resync"> & {
};

/**
 * Describes the message bazivan.v1.Resync.
 * Use `create(ResyncSchema)` to create a new message.
 */
export const ResyncSchema: GenMessage<Resync> = /*@__PURE__*/
  messageDesc(file_bazivan_v1_table, 45);

/**
 * کارتی از دست روی زمین. اگر بیش از یک ترکیبِ برداشت ممکن باشد، سرور
 * CbTableState با awaiting_capture می‌فرستد و منتظرِ CbPickCapture می‌مانَد.
 *
 * @generated from message bazivan.v1.CbPlay
 */
export type CbPlay = Message<"bazivan.v1.CbPlay"> & {
  /**
   * @generated from field: bazivan.v1.Card card = 1;
   */
  card?: Card | undefined;
};

/**
 * Describes the message bazivan.v1.CbPlay.
 * Use `create(CbPlaySchema)` to create a new message.
 */
export const CbPlaySchema: GenMessage<CbPlay> = /*@__PURE__*/
  messageDesc(file_bazivan_v1_table, 46);

/**
 * @generated from message bazivan.v1.CbPickCapture
 */
export type CbPickCapture = Message<"bazivan.v1.CbPickCapture"> & {
  /**
   * @generated from field: uint32 option = 1;
   */
  option: number;
};

/**
 * Describes the message bazivan.v1.CbPickCapture.
 * Use `create(CbPickCaptureSchema)` to create a new message.
 */
export const CbPickCaptureSchema: GenMessage<CbPickCapture> = /*@__PURE__*/
  messageDesc(file_bazivan_v1_table, 47);

/**
 * نشانِ سور: کارتِ رو و ۹۰درجه روی دسته‌ی جمع‌کننده.
 *
 * @generated from message bazivan.v1.SurMark
 */
export type SurMark = Message<"bazivan.v1.SurMark"> & {
  /**
   * @generated from field: uint32 seat = 1;
   */
  seat: number;

  /**
   * @generated from field: bazivan.v1.Card card = 2;
   */
  card?: Card | undefined;

  /**
   * ۵، یا ۱۰ برای سورِ سرباز
   *
   * @generated from field: uint32 worth = 3;
   */
  worth: number;
};

/**
 * Describes the message bazivan.v1.SurMark.
 * Use `create(SurMarkSchema)` to create a new message.
 */
export const SurMarkSchema: GenMessage<SurMark> = /*@__PURE__*/
  messageDesc(file_bazivan_v1_table, 48);

/**
 * @generated from message bazivan.v1.CaptureOption
 */
export type CaptureOption = Message<"bazivan.v1.CaptureOption"> & {
  /**
   * @generated from field: repeated bazivan.v1.Card cards = 1;
   */
  cards: Card[];
};

/**
 * Describes the message bazivan.v1.CaptureOption.
 * Use `create(CaptureOptionSchema)` to create a new message.
 */
export const CaptureOptionSchema: GenMessage<CaptureOption> = /*@__PURE__*/
  messageDesc(file_bazivan_v1_table, 49);

/**
 * نمای میزِ چهاربرگ از چشمِ یک صندلی (دستِ خودم واقعی، بقیه فقط شمارش).
 *
 * @generated from message bazivan.v1.CbTableState
 */
export type CbTableState = Message<"bazivan.v1.CbTableState"> & {
  /**
   * @generated from field: string table_id = 1;
   */
  tableId: string;

  /**
   * @generated from field: uint32 me = 2;
   */
  me: number;

  /**
   * @generated from field: repeated bazivan.v1.Seat seats = 3;
   */
  seats: Seat[];

  /**
   * @generated from field: repeated bazivan.v1.Card my_hand = 4;
   */
  myHand: Card[];

  /**
   * @generated from field: repeated uint32 hand_counts = 5;
   */
  handCounts: number[];

  /**
   * کارت‌های روی زمین، به ترتیب
   *
   * @generated from field: repeated bazivan.v1.Card table = 6;
   */
  table: Card[];

  /**
   * شمارِ کارت‌های جمع‌شده‌ی هر صندلی
   *
   * @generated from field: repeated uint32 pile_counts = 7;
   */
  pileCounts: number[];

  /**
   * @generated from field: repeated bazivan.v1.SurMark sur_marks = 8;
   */
  surMarks: SurMark[];

  /**
   * @generated from field: uint32 turn = 9;
   */
  turn: number;

  /**
   * @generated from field: uint32 deck_left = 10;
   */
  deckLeft: number;

  /**
   * امتیازِ مسابقه به ازای هر واحد
   *
   * @generated from field: repeated uint32 score = 11;
   */
  score: number[];

  /**
   * @generated from field: bool round_over = 12;
   */
  roundOver: boolean;

  /**
   * @generated from field: bool match_over = 13;
   */
  matchOver: boolean;

  /**
   * @generated from field: uint32 target_score = 14;
   */
  targetScore: number;

  /**
   * @generated from field: uint32 turn_deadline_ms = 15;
   */
  turnDeadlineMs: number;

  /**
   * من باید ترکیب را انتخاب کنم
   *
   * @generated from field: bool awaiting_capture = 16;
   */
  awaitingCapture: boolean;

  /**
   * @generated from field: bazivan.v1.Card capture_played = 17;
   */
  capturePlayed?: Card | undefined;

  /**
   * @generated from field: repeated bazivan.v1.CaptureOption capture_options = 18;
   */
  captureOptions: CaptureOption[];

  /**
   * دیگر پخشی نیست → سور حساب نمی‌شود
   *
   * @generated from field: bool last_deal = 19;
   */
  lastDeal: boolean;

  /**
   * @generated from field: int64 server_time_ms = 20;
   */
  serverTimeMs: bigint;

  /**
   * @generated from field: string carpet = 21;
   */
  carpet: string;

  /**
   * کدام ترکیبِ برداشت بهترین است — همان چیزی که ربات برمی‌دارد. نمایشی است،
   * ولی سرور می‌گوید تا قاعده‌ی ارزش‌گذاری در کلاینت تکرار نشود.
   *
   * @generated from field: uint32 capture_best = 22;
   */
  captureBest: number;

  /**
   * نمای تماشاچی — [[TableState.watching]]
   *
   * @generated from field: bool watching = 23;
   */
  watching: boolean;

  /**
   * @generated from field: uint32 watchers = 24;
   */
  watchers: number;

  /**
   * @generated from field: bool chat_open = 25;
   */
  chatOpen: boolean;

  /**
   * میزبانِ اتاق — [[TableState.host]]
   *
   * @generated from field: bool host = 26;
   */
  host: boolean;

  /**
   * v: شماره‌ی یکنواختِ میز در لحظه‌ی ساختنِ این پیام.
   *
   * هر میز یک شمارنده دارد که با هر پخشِ وضعیت و هر رویداد یکی جلو می‌رود.
   * کلاینت آخرین `v`ِ اعمال‌شده را نگه می‌دارد و هرچه کوچک‌تر یا مساوی باشد
   * دور می‌ریزد. چرا لازم است با وجودِ ترتیبِ تضمین‌شده‌ی TCP: پیام‌ها به‌ترتیب
   * *می‌رسند* ولی همیشه به‌ترتیب *اعمال* نمی‌شوند — سوکتِ کهنه‌ای که هنوز
   * نمرده فریم می‌دهد، و کلاینت گاهی پشتِ یک await وضعیت را دیر می‌نشانَد.
   * آن‌وقت عکسِ کهنه روی تازه می‌نشیند و میز عقب می‌پرد.
   *
   * @generated from field: uint64 v = 27;
   */
  v: bigint;

  /**
   * stake: ورودیِ سکه‌ایِ هر بازیکن که سرِ شروعِ همین میز برداشته شد؛ ۰ = رایگان.
   *
   * در **نمای میز** می‌آید و نه فقط در اتاق، چون پرده‌ی شرط باید هر جوری که
   * بازیکن سرِ میز رسیده بالا بیاید: بازیِ سریع اتاقی ندارد، بازگشت از قطعی
   * اتاق را دیگر نمی‌بیند، و تماشاچی اصلاً در اتاق نبوده. عددِ *واقعیِ*
   * برداشت‌شده است و نه خواسته‌ی اتاق — میزی که یکی‌شان پول نداشت رایگان
   * می‌شود و آن‌وقت نباید پرده‌ی شرط بالا بیاید.
   *
   * @generated from field: int64 stake = 28;
   */
  stake: bigint;
};

/**
 * Describes the message bazivan.v1.CbTableState.
 * Use `create(CbTableStateSchema)` to create a new message.
 */
export const CbTableStateSchema: GenMessage<CbTableState> = /*@__PURE__*/
  messageDesc(file_bazivan_v1_table, 50);

/**
 * رویدادهای لحظه‌ای برای انیمیشن؛ وضعیتِ کامل همیشه با CbTableState می‌آید.
 *
 * @generated from message bazivan.v1.CbEvent
 */
export type CbEvent = Message<"bazivan.v1.CbEvent"> & {
  /**
   * "ace_draw" | "played" | "captured" | "sur" | "sur_cancelled" | "deal" | "round_over" | "match_over" | "seat_bot" | "seat_reconnect"
   *
   * @generated from field: string kind = 1;
   */
  kind: string;

  /**
   * @generated from field: uint32 seat = 2;
   */
  seat: number;

  /**
   * @generated from field: bazivan.v1.Card card = 3;
   */
  card?: Card | undefined;

  /**
   * @generated from field: repeated bazivan.v1.Card captured = 4;
   */
  captured: Card[];

  /**
   * @generated from field: uint32 sur_worth = 5;
   */
  surWorth: number;

  /**
   * sur_cancelled: صندلیِ صاحبِ سورِ باطل‌شده
   *
   * @generated from field: uint32 victim = 6;
   */
  victim: number;

  /**
   * @generated from field: bazivan.v1.Card victim_card = 7;
   */
  victimCard?: Card | undefined;

  /**
   * round_over: امتیازِ این دور برای هر واحد
   *
   * @generated from field: repeated uint32 round_score = 8;
   */
  roundScore: number[];

  /**
   * @generated from field: uint32 winner_unit = 9;
   */
  winnerUnit: number;

  /**
   * v: شماره‌ی میز در لحظه‌ی این رویداد — [[TableState.v]].
   *
   * رویداد فقط نشانه‌ی انیمیشن است، پس دوباره‌فرستادنی نیست: اگر `v`ِ آن از
   * آخرین وضعیتِ اعمال‌شده عقب‌تر باشد، انیمیشنش مالِ گذشته است و باید
   * نادیده برود، نه این‌که کارتی را که همین حالا سرِ جایش است دوباره بپرانَد.
   *
   * @generated from field: uint64 v = 10;
   */
  v: bigint;

  /**
   * آس‌کشیِ آغازِ مسابقه ("ace_draw") — همان مراسمِ حکم، تا «چرا این نفر شروع
   * می‌کند» دیده شود و نه این‌که میز یکهو آماده باشد. ورق‌ها به ترتیبِ
   * رو‌شدن از `from_seat` دور می‌چرخند و آخری آس است؛ `seat` صندلیِ
   * شروع‌کننده. قرعه دستِ سرور می‌مانَد و این فقط نمایشش است.
   *
   * @generated from field: repeated bazivan.v1.Card draw = 11;
   */
  draw: Card[];

  /**
   * @generated from field: uint32 from_seat = 12;
   */
  fromSeat: number;
};

/**
 * Describes the message bazivan.v1.CbEvent.
 * Use `create(CbEventSchema)` to create a new message.
 */
export const CbEventSchema: GenMessage<CbEvent> = /*@__PURE__*/
  messageDesc(file_bazivan_v1_table, 51);

/**
 * ورقِ هفت خبیث: ورقِ استاندارد، یا کارتِ ویژه (special > 0؛ آن‌وقت card خالی است).
 * ۱ آینه، ۲ بمب، ۳ سپر، ۴ پنهان — همان ترتیبِ Bazivan.Core.Special.
 *
 * @generated from message bazivan.v1.HkCard
 */
export type HkCard = Message<"bazivan.v1.HkCard"> & {
  /**
   * @generated from field: bazivan.v1.Card card = 1;
   */
  card?: Card | undefined;

  /**
   * @generated from field: uint32 special = 2;
   */
  special: number;
};

/**
 * Describes the message bazivan.v1.HkCard.
 * Use `create(HkCardSchema)` to create a new message.
 */
export const HkCardSchema: GenMessage<HkCard> = /*@__PURE__*/
  messageDesc(file_bazivan_v1_table, 52);

/**
 * @generated from message bazivan.v1.HkPlay
 */
export type HkPlay = Message<"bazivan.v1.HkPlay"> & {
  /**
   * @generated from field: bazivan.v1.HkCard card = 1;
   */
  card?: HkCard | undefined;
};

/**
 * Describes the message bazivan.v1.HkPlay.
 * Use `create(HkPlaySchema)` to create a new message.
 */
export const HkPlaySchema: GenMessage<HkPlay> = /*@__PURE__*/
  messageDesc(file_bazivan_v1_table, 53);

/**
 * کشیدنِ کارت. با جریمه‌ی در راه یعنی «جریمه را می‌گیرم»؛ بعد از کشیدنِ کارتِ
 * بازی‌شدنی یعنی «رد می‌کنم».
 *
 * @generated from message bazivan.v1.HkDraw
 */
export type HkDraw = Message<"bazivan.v1.HkDraw"> & {
};

/**
 * Describes the message bazivan.v1.HkDraw.
 * Use `create(HkDrawSchema)` to create a new message.
 */
export const HkDrawSchema: GenMessage<HkDraw> = /*@__PURE__*/
  messageDesc(file_bazivan_v1_table, 54);

/**
 * @generated from message bazivan.v1.HkPickSuit
 */
export type HkPickSuit = Message<"bazivan.v1.HkPickSuit"> & {
  /**
   * @generated from field: bazivan.v1.Suit suit = 1;
   */
  suit: Suit;
};

/**
 * Describes the message bazivan.v1.HkPickSuit.
 * Use `create(HkPickSuitSchema)` to create a new message.
 */
export const HkPickSuitSchema: GenMessage<HkPickSuit> = /*@__PURE__*/
  messageDesc(file_bazivan_v1_table, 55);

/**
 * @generated from message bazivan.v1.HkPickTarget
 */
export type HkPickTarget = Message<"bazivan.v1.HkPickTarget"> & {
  /**
   * @generated from field: uint32 seat = 1;
   */
  seat: number;
};

/**
 * Describes the message bazivan.v1.HkPickTarget.
 * Use `create(HkPickTargetSchema)` to create a new message.
 */
export const HkPickTargetSchema: GenMessage<HkPickTarget> = /*@__PURE__*/
  messageDesc(file_bazivan_v1_table, 56);

/**
 * «تک‌کارت!» — با یک برگ در دست، پیش از پایانِ مهلت. نزنی، یک برگ جریمه.
 *
 * @generated from message bazivan.v1.HkCallWarn
 */
export type HkCallWarn = Message<"bazivan.v1.HkCallWarn"> & {
};

/**
 * Describes the message bazivan.v1.HkCallWarn.
 * Use `create(HkCallWarnSchema)` to create a new message.
 */
export const HkCallWarnSchema: GenMessage<HkCallWarn> = /*@__PURE__*/
  messageDesc(file_bazivan_v1_table, 57);

/**
 * «مچ‌گیری!» — رباتی تک‌کارتش را فراموش کرده و پنجره باز است؛ بگیری، او جریمه می‌شود.
 *
 * @generated from message bazivan.v1.HkCatch
 */
export type HkCatch = Message<"bazivan.v1.HkCatch"> & {
};

/**
 * Describes the message bazivan.v1.HkCatch.
 * Use `create(HkCatchSchema)` to create a new message.
 */
export const HkCatchSchema: GenMessage<HkCatch> = /*@__PURE__*/
  messageDesc(file_bazivan_v1_table, 58);

/**
 * «تعارفِ ۲»: قربانی یکی از کارت‌های روبسته‌ی بازی‌کننده‌ی ۲ را انتخاب می‌کند.
 *
 * @generated from message bazivan.v1.HkPickOffer
 */
export type HkPickOffer = Message<"bazivan.v1.HkPickOffer"> & {
  /**
   * @generated from field: uint32 index = 1;
   */
  index: number;
};

/**
 * Describes the message bazivan.v1.HkPickOffer.
 * Use `create(HkPickOfferSchema)` to create a new message.
 */
export const HkPickOfferSchema: GenMessage<HkPickOffer> = /*@__PURE__*/
  messageDesc(file_bazivan_v1_table, 59);

/**
 * نمای میز از چشمِ یک صندلی. قاعده‌ای در کلاینت تکرار نمی‌شود: کدام کارتِ من
 * بازی‌شدنی است را سرور در my_playable می‌گوید.
 *
 * @generated from message bazivan.v1.HkTableState
 */
export type HkTableState = Message<"bazivan.v1.HkTableState"> & {
  /**
   * @generated from field: string table_id = 1;
   */
  tableId: string;

  /**
   * @generated from field: uint32 me = 2;
   */
  me: number;

  /**
   * @generated from field: repeated bazivan.v1.Seat seats = 3;
   */
  seats: Seat[];

  /**
   * @generated from field: repeated bazivan.v1.HkCard my_hand = 4;
   */
  myHand: HkCard[];

  /**
   * هم‌ایندکس با my_hand
   *
   * @generated from field: repeated bool my_playable = 5;
   */
  myPlayable: boolean[];

  /**
   * @generated from field: repeated uint32 hand_counts = 6;
   */
  handCounts: number[];

  /**
   * کارتِ روِ زمین
   *
   * @generated from field: bazivan.v1.HkCard top = 7;
   */
  top?: HkCard | undefined;

  /**
   * خالِ جاری (سرباز عوضش می‌کند)
   *
   * @generated from field: bazivan.v1.Suit top_suit = 8;
   */
  topSuit: Suit;

  /**
   * @generated from field: uint32 turn = 9;
   */
  turn: number;

  /**
   * ‎+۱ ساعت‌گرد، ‎-۱ پادساعت‌گرد
   *
   * @generated from field: int32 dir = 10;
   */
  dir: number;

  /**
   * جریمه‌ی انباشته‌ی ۷
   *
   * @generated from field: uint32 pending_draw = 11;
   */
  pendingDraw: number;

  /**
   * @generated from field: uint32 seven_chain = 12;
   */
  sevenChain: number;

  /**
   * من باید خال بخوانم
   *
   * @generated from field: bool awaiting_suit = 13;
   */
  awaitingSuit: boolean;

  /**
   * من باید هدفِ ۲ را بگویم
   *
   * @generated from field: bool awaiting_target = 14;
   */
  awaitingTarget: boolean;

  /**
   * من باید ادامه‌ی ۸ را بگذارم
   *
   * @generated from field: bool awaiting_bonus = 15;
   */
  awaitingBonus: boolean;

  /**
   * @generated from field: bazivan.v1.Suit bonus_suit = 16;
   */
  bonusSuit: Suit;

  /**
   * کشیدم و می‌توانم رد کنم
   *
   * @generated from field: bool can_pass = 17;
   */
  canPass: boolean;

  /**
   * آینه‌ی مسلحِ هر صندلی — همه می‌بینند
   *
   * @generated from field: repeated bool mirrored = 18;
   */
  mirrored: boolean[];

  /**
   * @generated from field: uint32 deck_left = 19;
   */
  deckLeft: number;

  /**
   * جریمه‌ی تجمعی؛ کم‌تر بهتر
   *
   * @generated from field: repeated uint32 scores = 20;
   */
  scores: number[];

  /**
   * @generated from field: uint32 target_score = 21;
   */
  targetScore: number;

  /**
   * @generated from field: bool round_over = 22;
   */
  roundOver: boolean;

  /**
   * @generated from field: bool match_over = 23;
   */
  matchOver: boolean;

  /**
   * برنده‌ی دور (‎-۱ = هنوز)
   *
   * @generated from field: int32 winner = 24;
   */
  winner: number;

  /**
   * @generated from field: int32 match_winner = 25;
   */
  matchWinner: number;

  /**
   * @generated from field: uint32 turn_deadline_ms = 26;
   */
  turnDeadlineMs: number;

  /**
   * @generated from field: int64 server_time_ms = 27;
   */
  serverTimeMs: bigint;

  /**
   * حالتِ خبیث (کارتِ ویژه دارد)
   *
   * @generated from field: bool evil = 28;
   */
  evil: boolean;

  /**
   * تک‌کارت: من یک برگ دارم و مهلتِ «تک‌کارت!» باز است.
   *
   * @generated from field: bool warn_open = 29;
   */
  warnOpen: boolean;

  /**
   * @generated from field: uint32 warn_ms_left = 30;
   */
  warnMsLeft: number;

  /**
   * مچ‌گیری: رباتِ catch_seat تک‌کارتش را فراموش کرده؛ پنجره تا catch_ms_left باز است.
   *
   * @generated from field: bool catch_open = 31;
   */
  catchOpen: boolean;

  /**
   * @generated from field: int32 catch_seat = 32;
   */
  catchSeat: number;

  /**
   * @generated from field: uint32 catch_ms_left = 33;
   */
  catchMsLeft: number;

  /**
   * تعارفِ ۲: من قربانی‌ام و باید یکی از offer_count کارتِ روبسته‌ی offer_from را بردارم.
   *
   * @generated from field: bool awaiting_offer = 34;
   */
  awaitingOffer: boolean;

  /**
   * @generated from field: int32 offer_from = 35;
   */
  offerFrom: number;

  /**
   * @generated from field: uint32 offer_count = 36;
   */
  offerCount: number;

  /**
   * @generated from field: string carpet = 37;
   */
  carpet: string;

  /**
   * کارنامه‌ی دورهای گذشته — برای جدولِ نتایج. در وضعیت می‌آید و نه فقط در
   * رویداد، وگرنه هر تازه‌کردنِ صفحه تاریخچه را پاک می‌کرد.
   *
   * @generated from field: repeated bazivan.v1.HkRound rounds = 38;
   */
  rounds: HkRound[];

  /**
   * نمای تماشاچی — [[TableState.watching]]
   *
   * @generated from field: bool watching = 39;
   */
  watching: boolean;

  /**
   * @generated from field: uint32 watchers = 40;
   */
  watchers: number;

  /**
   * @generated from field: bool chat_open = 41;
   */
  chatOpen: boolean;

  /**
   * میزبانِ اتاق — [[TableState.host]]
   *
   * @generated from field: bool host = 42;
   */
  host: boolean;

  /**
   * v: شماره‌ی یکنواختِ میز در لحظه‌ی ساختنِ این پیام.
   *
   * هر میز یک شمارنده دارد که با هر پخشِ وضعیت و هر رویداد یکی جلو می‌رود.
   * کلاینت آخرین `v`ِ اعمال‌شده را نگه می‌دارد و هرچه کوچک‌تر یا مساوی باشد
   * دور می‌ریزد. چرا لازم است با وجودِ ترتیبِ تضمین‌شده‌ی TCP: پیام‌ها به‌ترتیب
   * *می‌رسند* ولی همیشه به‌ترتیب *اعمال* نمی‌شوند — سوکتِ کهنه‌ای که هنوز
   * نمرده فریم می‌دهد، و کلاینت گاهی پشتِ یک await وضعیت را دیر می‌نشانَد.
   * آن‌وقت عکسِ کهنه روی تازه می‌نشیند و میز عقب می‌پرد.
   *
   * @generated from field: uint64 v = 43;
   */
  v: bigint;

  /**
   * stake: ورودیِ سکه‌ایِ هر بازیکن که سرِ شروعِ همین میز برداشته شد؛ ۰ = رایگان.
   *
   * در **نمای میز** می‌آید و نه فقط در اتاق، چون پرده‌ی شرط باید هر جوری که
   * بازیکن سرِ میز رسیده بالا بیاید: بازیِ سریع اتاقی ندارد، بازگشت از قطعی
   * اتاق را دیگر نمی‌بیند، و تماشاچی اصلاً در اتاق نبوده. عددِ *واقعیِ*
   * برداشت‌شده است و نه خواسته‌ی اتاق — میزی که یکی‌شان پول نداشت رایگان
   * می‌شود و آن‌وقت نباید پرده‌ی شرط بالا بیاید.
   *
   * @generated from field: int64 stake = 44;
   */
  stake: bigint;
};

/**
 * Describes the message bazivan.v1.HkTableState.
 * Use `create(HkTableStateSchema)` to create a new message.
 */
export const HkTableStateSchema: GenMessage<HkTableState> = /*@__PURE__*/
  messageDesc(file_bazivan_v1_table, 60);

/**
 * یک دورِ تمام‌شده: امتیازِ همان دور برای هر صندلی و برنده‌اش.
 *
 * @generated from message bazivan.v1.HkRound
 */
export type HkRound = Message<"bazivan.v1.HkRound"> & {
  /**
   * @generated from field: repeated uint32 points = 1;
   */
  points: number[];

  /**
   * @generated from field: uint32 winner = 2;
   */
  winner: number;
};

/**
 * Describes the message bazivan.v1.HkRound.
 * Use `create(HkRoundSchema)` to create a new message.
 */
export const HkRoundSchema: GenMessage<HkRound> = /*@__PURE__*/
  messageDesc(file_bazivan_v1_table, 61);

/**
 * رویدادهای لحظه‌ای برای انیمیشن؛ وضعیتِ کامل همیشه با HkTableState می‌آید.
 *
 * @generated from message bazivan.v1.HkEvent
 */
export type HkEvent = Message<"bazivan.v1.HkEvent"> & {
  /**
   * kind: "ace_draw" | "deal" | "played" | "drew" | "penalty" | "suit" | "target" | "offer" | "skip" | "reverse" | "bomb" | "mirror"
   *     | "warn" (seat تک‌کارت را اعلام کرد) | "forgot" (seat یادش رفت و جریمه شد)
   *     | "caught" (seat مچِ victim را گرفت) | "round_over" | "match_over" | "seat_bot" | "seat_reconnect"
   *
   * @generated from field: string kind = 1;
   */
  kind: string;

  /**
   * @generated from field: uint32 seat = 2;
   */
  seat: number;

  /**
   * @generated from field: bazivan.v1.HkCard card = 3;
   */
  card?: HkCard | undefined;

  /**
   * drew/penalty/offer: چند کارت
   *
   * @generated from field: uint32 count = 4;
   */
  count: number;

  /**
   * suit: خالِ تازه
   *
   * @generated from field: bazivan.v1.Suit suit = 5;
   */
  suit: Suit;

  /**
   * target/offer/bomb/caught: کی خورد
   *
   * @generated from field: uint32 victim = 6;
   */
  victim: number;

  /**
   * @generated from field: repeated uint32 round_points = 7;
   */
  roundPoints: number[];

  /**
   * @generated from field: uint32 winner = 8;
   */
  winner: number;

  /**
   * v: شماره‌ی میز در لحظه‌ی این رویداد — [[TableState.v]].
   *
   * رویداد فقط نشانه‌ی انیمیشن است، پس دوباره‌فرستادنی نیست: اگر `v`ِ آن از
   * آخرین وضعیتِ اعمال‌شده عقب‌تر باشد، انیمیشنش مالِ گذشته است و باید
   * نادیده برود، نه این‌که کارتی را که همین حالا سرِ جایش است دوباره بپرانَد.
   *
   * @generated from field: uint64 v = 9;
   */
  v: bigint;

  /**
   * آس‌کشیِ آغازِ مسابقه ("ace_draw") — مثلِ حکم و چهاربرگ. ورقِ ساده است و
   * نه HkCard: مراسم پیش از پخش است و ورقِ ویژه در آن نقشی ندارد.
   *
   * @generated from field: repeated bazivan.v1.Card draw = 10;
   */
  draw: Card[];

  /**
   * @generated from field: uint32 from_seat = 11;
   */
  fromSeat: number;
};

/**
 * Describes the message bazivan.v1.HkEvent.
 * Use `create(HkEventSchema)` to create a new message.
 */
export const HkEventSchema: GenMessage<HkEvent> = /*@__PURE__*/
  messageDesc(file_bazivan_v1_table, 62);

/**
 * ShBid: خواندن یا پاس. `pass` که true باشد `amount` خوانده نمی‌شود — پاس با
 * «عددِ منفی» روی سیم نمی‌آید، چون uint نداریم و علامتِ منفی یک قراردادِ
 * نانوشته می‌شد که هر کلاینتی باید یادش می‌ماند.
 *
 * @generated from message bazivan.v1.ShBid
 */
export type ShBid = Message<"bazivan.v1.ShBid"> & {
  /**
   * @generated from field: bool pass = 1;
   */
  pass: boolean;

  /**
   * ۱۰۰ تا ۱۶۵، مضربِ ۵
   *
   * @generated from field: uint32 amount = 2;
   */
  amount: number;
};

/**
 * Describes the message bazivan.v1.ShBid.
 * Use `create(ShBidSchema)` to create a new message.
 */
export const ShBidSchema: GenMessage<ShBid> = /*@__PURE__*/
  messageDesc(file_bazivan_v1_table, 63);

/**
 * ShDiscard: حاکم ۴ برگ از ۱۶ برگش برمی‌گرداند. همان‌ها جزوِ بردِ تیمش‌اند.
 *
 * @generated from message bazivan.v1.ShDiscard
 */
export type ShDiscard = Message<"bazivan.v1.ShDiscard"> & {
  /**
   * @generated from field: repeated bazivan.v1.Card cards = 1;
   */
  cards: Card[];
};

/**
 * Describes the message bazivan.v1.ShDiscard.
 * Use `create(ShDiscardSchema)` to create a new message.
 */
export const ShDiscardSchema: GenMessage<ShDiscard> = /*@__PURE__*/
  messageDesc(file_bazivan_v1_table, 64);

/**
 * ShTrump: حاکم حکم را اعلام می‌کند.
 *
 * @generated from message bazivan.v1.ShTrump
 */
export type ShTrump = Message<"bazivan.v1.ShTrump"> & {
  /**
   * @generated from field: bazivan.v1.Suit suit = 1;
   */
  suit: Suit;
};

/**
 * Describes the message bazivan.v1.ShTrump.
 * Use `create(ShTrumpSchema)` to create a new message.
 */
export const ShTrumpSchema: GenMessage<ShTrump> = /*@__PURE__*/
  messageDesc(file_bazivan_v1_table, 65);

/**
 * @generated from message bazivan.v1.ShPlay
 */
export type ShPlay = Message<"bazivan.v1.ShPlay"> & {
  /**
   * @generated from field: bazivan.v1.Card card = 1;
   */
  card?: Card | undefined;
};

/**
 * Describes the message bazivan.v1.ShPlay.
 * Use `create(ShPlaySchema)` to create a new message.
 */
export const ShPlaySchema: GenMessage<ShPlay> = /*@__PURE__*/
  messageDesc(file_bazivan_v1_table, 66);

/**
 * نمای میزِ شلم از چشمِ یک صندلی — دستِ خودم واقعی، بقیه فقط شمارش.
 *
 * @generated from message bazivan.v1.ShTableState
 */
export type ShTableState = Message<"bazivan.v1.ShTableState"> & {
  /**
   * @generated from field: string table_id = 1;
   */
  tableId: string;

  /**
   * @generated from field: uint32 me = 2;
   */
  me: number;

  /**
   * @generated from field: repeated bazivan.v1.Seat seats = 3;
   */
  seats: Seat[];

  /**
   * در مرحله‌ی واگذاری ۱۶ برگ است
   *
   * @generated from field: repeated bazivan.v1.Card my_hand = 4;
   */
  myHand: Card[];

  /**
   * @generated from field: repeated uint32 hand_counts = 5;
   */
  handCounts: number[];

  /**
   * @generated from field: bazivan.v1.ShPhase phase = 6;
   */
  phase: ShPhase;

  /**
   * ── مزایده ──
   *
   * @generated from field: uint32 dealer = 7;
   */
  dealer: number;

  /**
   * @generated from field: uint32 bid_turn = 8;
   */
  bidTurn: number;

  /**
   * @generated from field: repeated bool passed = 9;
   */
  passed: boolean[];

  /**
   * @generated from field: uint32 high_bid = 10;
   */
  highBid: number;

  /**
   * ‎-۱ یعنی هنوز کسی نخوانده
   *
   * @generated from field: int32 high_seat = 11;
   */
  highSeat: number;

  /**
   * کمترین عددِ خواندنی همین حالا
   *
   * @generated from field: uint32 bid_floor = 12;
   */
  bidFloor: number;

  /**
   * کفِ خواندن هنوز زیرِ سقف است
   *
   * @generated from field: bool can_raise = 13;
   */
  canRaise: boolean;

  /**
   * *من* شروع‌کننده‌ام و پاس ندارم
   *
   * @generated from field: bool must_bid = 14;
   */
  mustBid: boolean;

  /**
   * ── حاکم و حکم ──
   *
   * ‎-۱ تا پایانِ مزایده
   *
   * @generated from field: int32 declarer = 15;
   */
  declarer: number;

  /**
   * @generated from field: uint32 bid = 16;
   */
  bid: number;

  /**
   * @generated from field: bazivan.v1.Suit trump = 17;
   */
  trump: Suit;

  /**
   * @generated from field: bool trump_chosen = 18;
   */
  trumpChosen: boolean;

  /**
   * ── دست ──
   *
   * @generated from field: uint32 turn = 19;
   */
  turn: number;

  /**
   * به ایندکسِ صندلی؛ خانه‌ی خالی = هنوز نزده
   *
   * @generated from field: repeated bazivan.v1.Card trick = 20;
   */
  trick: Card[];

  /**
   * کدام خانه‌ها پر است (خالیِ Card از «نزده» جدا نمی‌شود)
   *
   * @generated from field: repeated bool trick_played = 21;
   */
  trickPlayed: boolean[];

  /**
   * @generated from field: uint32 trick_leader = 22;
   */
  trickLeader: number;

  /**
   * @generated from field: bazivan.v1.Suit led_suit = 23;
   */
  ledSuit: Suit;

  /**
   * @generated from field: bool trick_has_lead = 24;
   */
  trickHasLead: boolean;

  /**
   * به ازای هر واحد
   *
   * @generated from field: repeated uint32 tricks_won = 25;
   */
  tricksWon: number[];

  /**
   * امتیازِ جمع‌شده‌ی هر واحد تا این لحظه (جمعشان ۱۶۵)
   *
   * @generated from field: repeated uint32 collected = 26;
   */
  collected: number[];

  /**
   * ── مسابقه ──
   *
   * امتیازِ تجمعی؛ منفی هم می‌شود، پس int
   *
   * @generated from field: repeated int32 score = 27;
   */
  score: number[];

  /**
   * @generated from field: uint32 target_score = 28;
   */
  targetScore: number;

  /**
   * @generated from field: bool hand_over = 29;
   */
  handOver: boolean;

  /**
   * @generated from field: bool match_over = 30;
   */
  matchOver: boolean;

  /**
   * ── مشترک با بقیه‌ی میزها ──
   *
   * @generated from field: uint32 turn_deadline_ms = 31;
   */
  turnDeadlineMs: number;

  /**
   * @generated from field: int64 server_time_ms = 32;
   */
  serverTimeMs: bigint;

  /**
   * @generated from field: string carpet = 33;
   */
  carpet: string;

  /**
   * [[TableState.watching]]
   *
   * @generated from field: bool watching = 34;
   */
  watching: boolean;

  /**
   * @generated from field: uint32 watchers = 35;
   */
  watchers: number;

  /**
   * @generated from field: bool chat_open = 36;
   */
  chatOpen: boolean;

  /**
   * @generated from field: bool host = 37;
   */
  host: boolean;

  /**
   * [[TableState.v]]
   *
   * @generated from field: uint64 v = 38;
   */
  v: bigint;

  /**
   * [[CbTableState.stake]]
   *
   * @generated from field: int64 stake = 39;
   */
  stake: bigint;
};

/**
 * Describes the message bazivan.v1.ShTableState.
 * Use `create(ShTableStateSchema)` to create a new message.
 */
export const ShTableStateSchema: GenMessage<ShTableState> = /*@__PURE__*/
  messageDesc(file_bazivan_v1_table, 67);

/**
 * رویدادهای لحظه‌ای برای انیمیشن؛ وضعیتِ کامل همیشه با ShTableState می‌آید.
 *
 * @generated from message bazivan.v1.ShEvent
 */
export type ShEvent = Message<"bazivan.v1.ShEvent"> & {
  /**
   * "ace_draw" | "deal" | "bid" | "pass" | "declarer" | "widow" | "discard"
   * | "trump_called" | "played" | "trick_won" | "hand_over" | "match_over"
   * | "seat_bot" | "seat_reconnect"
   *
   * @generated from field: string kind = 1;
   */
  kind: string;

  /**
   * @generated from field: uint32 seat = 2;
   */
  seat: number;

  /**
   * @generated from field: bazivan.v1.Card card = 3;
   */
  card?: Card | undefined;

  /**
   * "bid": عددِ خوانده‌شده
   *
   * @generated from field: uint32 amount = 4;
   */
  amount: number;

  /**
   * "trump_called"
   *
   * @generated from field: bazivan.v1.Suit suit = 5;
   */
  suit: Suit;

  /**
   * "widow" و "discard" — چهار برگ
   *
   * @generated from field: repeated bazivan.v1.Card cards = 6;
   */
  cards: Card[];

  /**
   * "hand_over": امتیازِ این دور برای هر واحد
   *
   * @generated from field: repeated int32 round_score = 7;
   */
  roundScore: number[];

  /**
   * @generated from field: uint32 winner_unit = 8;
   */
  winnerUnit: number;

  /**
   * "hand_over": هر ۱۲ دست
   *
   * @generated from field: bool shelem = 9;
   */
  shelem: boolean;

  /**
   * @generated from field: bool kot = 10;
   */
  kot: boolean;

  /**
   * @generated from field: bool yasa = 11;
   */
  yasa: boolean;

  /**
   * [[TableState.v]]
   *
   * @generated from field: uint64 v = 12;
   */
  v: bigint;

  /**
   * آس‌کشیِ آغازِ مسابقه ("ace_draw") — مثلِ بقیه‌ی میزها.
   *
   * @generated from field: repeated bazivan.v1.Card draw = 13;
   */
  draw: Card[];

  /**
   * @generated from field: uint32 from_seat = 14;
   */
  fromSeat: number;
};

/**
 * Describes the message bazivan.v1.ShEvent.
 * Use `create(ShEventSchema)` to create a new message.
 */
export const ShEventSchema: GenMessage<ShEvent> = /*@__PURE__*/
  messageDesc(file_bazivan_v1_table, 68);

/**
 * @generated from enum bazivan.v1.Suit
 */
export enum Suit {
  /**
   * @generated from enum value: SUIT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SUIT_HEARTS = 1;
   */
  HEARTS = 1,

  /**
   * @generated from enum value: SUIT_DIAMONDS = 2;
   */
  DIAMONDS = 2,

  /**
   * @generated from enum value: SUIT_SPADES = 3;
   */
  SPADES = 3,

  /**
   * @generated from enum value: SUIT_CLUBS = 4;
   */
  CLUBS = 4,
}

/**
 * Describes the enum bazivan.v1.Suit.
 */
export const SuitSchema: GenEnum<Suit> = /*@__PURE__*/
  enumDesc(file_bazivan_v1_table, 0);

/**
 * @generated from enum bazivan.v1.Rank
 */
export enum Rank {
  /**
   * @generated from enum value: RANK_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: RANK_ACE = 1;
   */
  ACE = 1,

  /**
   * @generated from enum value: RANK_TWO = 2;
   */
  TWO = 2,

  /**
   * @generated from enum value: RANK_THREE = 3;
   */
  THREE = 3,

  /**
   * @generated from enum value: RANK_FOUR = 4;
   */
  FOUR = 4,

  /**
   * @generated from enum value: RANK_FIVE = 5;
   */
  FIVE = 5,

  /**
   * @generated from enum value: RANK_SIX = 6;
   */
  SIX = 6,

  /**
   * @generated from enum value: RANK_SEVEN = 7;
   */
  SEVEN = 7,

  /**
   * @generated from enum value: RANK_EIGHT = 8;
   */
  EIGHT = 8,

  /**
   * @generated from enum value: RANK_NINE = 9;
   */
  NINE = 9,

  /**
   * @generated from enum value: RANK_TEN = 10;
   */
  TEN = 10,

  /**
   * @generated from enum value: RANK_JACK = 11;
   */
  JACK = 11,

  /**
   * @generated from enum value: RANK_QUEEN = 12;
   */
  QUEEN = 12,

  /**
   * @generated from enum value: RANK_KING = 13;
   */
  KING = 13,
}

/**
 * Describes the enum bazivan.v1.Rank.
 */
export const RankSchema: GenEnum<Rank> = /*@__PURE__*/
  enumDesc(file_bazivan_v1_table, 1);

/**
 * ShPhase: کجای دست هستیم — همتای shelem.Phase در سرور. کلاینت از رویش
 * می‌فهمد چه چیزی از بازیکن بپرسد و چه چیزی را فقط نشان بدهد.
 *
 * @generated from enum bazivan.v1.ShPhase
 */
export enum ShPhase {
  /**
   * @generated from enum value: SH_PHASE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SH_PHASE_BID = 1;
   */
  BID = 1,

  /**
   * @generated from enum value: SH_PHASE_DISCARD = 2;
   */
  DISCARD = 2,

  /**
   * @generated from enum value: SH_PHASE_TRUMP = 3;
   */
  TRUMP = 3,

  /**
   * @generated from enum value: SH_PHASE_PLAY = 4;
   */
  PLAY = 4,

  /**
   * @generated from enum value: SH_PHASE_OVER = 5;
   */
  OVER = 5,
}

/**
 * Describes the enum bazivan.v1.ShPhase.
 */
export const ShPhaseSchema: GenEnum<ShPhase> = /*@__PURE__*/
  enumDesc(file_bazivan_v1_table, 2);

